<template>
  <div>
    <div class="flex flex-col p-5">
      <p class="font-semibold text-3xl">
        List Barge Line Up
      </p>
      <div class="filter-container items-start gap-2">
        <p class="font-medium mt-4 text-base">
          Filter
        </p>
        <div class="w-full flex items-center gap-2 flex-wrap">
          <date-picker
            :disabled="isEditMode"
            v-model="filter.date"
            type="month"
            value-type="format"
            format="MMM-YYYY"
            placeholder="Select Loading Date"
            range
            :clearable="false"
            :input-attr="{ readonly: true }"
            :custom-disabled-date="disabledDate"
          />
          <select-with-multiple
            :disabled="isEditMode"
            activate-search
            :key="DOC_ASSIGNMENT.length"
            v-model="filter.doc_assignment"
            style="max-width: 198px;"
            placeholder="Select Doc. Status"
            :options="DOC_ASSIGNMENT"
          />
          <select-with-multiple
            :is-busy="fetchLoading.vesselOptions"
            :disabled="isEditMode || fetchLoading.vesselOptions"
            activate-search
            v-model="filter.name_of_vessel"
            style="max-width: 198px;"
            :options="vesselOptions"
            placeholder="Select Vessel"
          />
          <select-with-multiple
            :is-busy="fetchLoading.bargeOptions"
            :disabled="isEditMode || fetchLoading.bargeOptions"
            activate-search
            :key="bargeOptions.length"
            v-model="filter.barge"
            style="max-width: 198px;"
            placeholder="Select barge"
            :options="bargeOptions"
          />
          <select-with-multiple
            :is-busy="fetchLoading.routeOptions"
            :disabled="isEditMode || fetchLoading.routeOptions"
            activate-search
            v-model="filter.route"
            style="max-width: 198px;"
            placeholder="Select route"
            :options="routeOptions"
          />
          <select-with-multiple
            :is-busy="fetchLoading.productOptions"
            :disabled="isEditMode || fetchLoading.productOptions"
            activate-search
            v-model="filter.product_id"
            style="max-width: 198px;"
            placeholder="Select product id"
            :options="productIdOptions"
          />
          <vs-button
            :disabled="isEditMode"
            color="primary"
            class="p-4 w-[100px] h-[50px] self-end font-semibold ml-auto"
            @click="resetFilters"
          >
            Reset
          </vs-button>
        </div>
      </div>


      <div class="p-5 flex flex-col mt-5 bg-white rounded-md">
        <table-top
          is-search-has-border
          :page-size-start="false"
          :hide-page-limit-selection="isEditMode"
          :hide-search="isEditMode"
          class="mt-6"
          @fetch="fetchBarges"
          ref="tabletop"
          :default-search="defaultSearch"
        >
          <template #start>
            <div class="flex flex-row">
              <template v-if="isEditMode">
                <vs-button
                  :disabled="isBulkEditProcessing"
                  v-show="isUserCanAccessMenu(permission.name, 'add')"
                  :class="`button font-semibold ml-5 bg-primary-accent ${isBulkEditProcessing && 'animate-bounce'} `"
                  @click="saveBulkEdit"
                >
                  Save Changes
                </vs-button>
                <vs-button
                  :disabled="isBulkEditProcessing"
                  type="border"
                  :class="`button font-semibold ml-5 border-red-700 !bg-transparent text-red-700 ${isBulkEditProcessing && 'animate-bounce'}`"
                  @click="isPopUpDiscardShown = true"
                >
                  Discard Changes
                </vs-button>
              </template>
              <template v-else>
                <div class="grid grid-cols-3 gap-2">
                  <vs-button
                    v-show="isUserCanAccessMenu(permission.name, 'add')"
                    color="primary"
                    class="button font-semibold h-16"
                    @click="$router.push({ name: 'BargeLineUpUpload' })"
                  >
                    Upload BLU Plan
                  </vs-button>
                  <vs-button
                    v-show="isUserCanAccessMenu(permission.name, 'edit')"
                    class="button font-semibold bg-primary-accent h-16"
                    color=""
                    @click="setEditMode"
                  >
                    Edit Mode
                  </vs-button>
                  <vs-button
                    ref="buttonExport"
                    class="button font-semibold h-16"
                    color="secondary"
                    @click="isDownload = true"
                    :disabled="isDownload"
                  >
                    Export BLU
                  </vs-button>
                  <vs-button
                    class="button font-semibold h-16"
                    color="secondary"
                    @click="onHandleSendEmail"
                    :disabled="isSendEmail"
                    v-if="isUserCanAccessMenu(permission.name, 'edit')"
                  >
                    Send Email
                  </vs-button>
                  <div
                    v-if="isDownload"
                    class="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex"
                    style="z-index: 1000"
                    @click.self="isDownload = false"
                  >
                    <div
                      class="bg-white p-3 rounded shadow-xl"
                      style="height: fit-content"
                      :style="{
                        marginTop: `${modalExportPosition.top}px`,
                        marginLeft: `${modalExportPosition.left}px`
                      }"
                    >
                      <div class="flex flex-col items-start gap-1">
                        <vs-button
                          :class="`w-full flex justify-start ${fetchLoading.exportBLU.BO && 'cursor-not-allowed animate-bounce'}`"
                          type="flat"
                          color="dark"
                          :disabled="fetchLoading.exportBLU.BO"
                          @click="downloadBOReport('BO')"
                        >
                          <div class="flex flex-row items-start gap-2">
                            <img
                              :src="require('@/assets/shipo-icon-file-download.svg')"
                              alt="Download Daily Bunker Report"
                            >
                            <span class="font-semibold underline">
                              BO Template
                            </span>
                          </div>
                        </vs-button>
                        <vs-button
                          :class="`w-full flex justify-start ${fetchLoading.exportBLU.BLU && 'cursor-not-allowed animate-bounce'}`"
                          type="flat"
                          color="dark"
                          :disabled="fetchLoading.exportBLU.BLU"
                          @click="downloadBOReport('BLU')"
                        >
                          <div class="flex flex-row gap-2">
                            <img
                              :src="require('@/assets/shipo-icon-file-download.svg')"
                              alt="Download Fuel Supply Report"
                            >
                            <span class="font-semibold underline">
                              BLU Report V1
                            </span>
                          </div>
                        </vs-button>
                        <vs-button
                          :class="`w-full flex justify-start ${fetchLoading.exportBLU.BLUV2 && 'cursor-not-allowed animate-bounce'}`"
                          type="flat"
                          color="dark"
                          :disabled="fetchLoading.exportBLU.BLUV2"
                          @click="downloadBOReport('BLUV2')"
                        >
                          <div class="flex flex-row gap-2">
                            <img
                              :src="require('@/assets/shipo-icon-file-download.svg')"
                              alt="Download Fuel Supply Report"
                            >
                            <span class="font-semibold underline">
                              BLU Report V2
                            </span>
                          </div>
                        </vs-button>
                      </div>
                    </div>
                  </div>
                  <vs-button
                    class="button font-semibold h-16"
                    color="primary"
                    type="border"
                    @click="submitBulkAssign"
                    :disabled="!selectedRow.length"
                    v-if="isUserCanAccessMenu(permission.name, 'edit')"
                  >
                    Assign BLU
                  </vs-button>
                  <div
                    v-if="isUserCanAccessMenu(permission.name, 'delete')"
                    :class="`flex w-1/2 px-auto max-h-[20px] rounded-lg justify-center ${isDisabledDeleteButton() ? 'cursor-none' : 'cursor-pointer'}`"
                    :style="{ backgroundColor: isDisabledDeleteButton() ? '#DEDEDE' : '#B01E47' }"
                    @click="isDisabledDeleteButton() ? null : submitBulkDelete()"
                  >
                    <img
                      :src="require('@/assets/shipo-icon-delete.svg')"
                      alt="trash"
                      class="h-1/2"
                    >
                  </div>
                </div>
              </template>
            </div>
          </template>
        </table-top>
        <template v-if="isEditMode">
          <vue-excel-editor
            ref="excel"
            v-model="tableDataForExcel"
            :editable="true"
            width="auto"
            :autocomplete-count="10000000000"
            class="flex m-4"
            :readonly-style="{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }"
            :cell-style="setCellStyle"
            :no-header-edit="true"
            no-paging
            :free-select="false"
            v-fix-scroll
          >
            <template v-for="(tr, index) in tableHeadersExcel">
              <vue-excel-column
                width="150px"
                :key="index"
                :readonly="tr.isDisabled || isBulkEditProcessing"
                :field="tr.key"
                :default="0"
                :label="tr.group === 'general' || tr.group === 'simulation'
                  ? tr.label
                  : tr.group.toUpperCase() + ' ' + tr.label"
                :type="
                  tr.isNumber === true
                    ? 'number'
                    : tr.isFreeInput || tr.isDate ? 'string' : 'select'
                "
                :sticky="tr.freeze"
                :change="onCellChange"
                :options="isCellNotDropdown(tr) ? null : (_, col) => populateOptions(col, tr)"
                :validate="(content, oldContent, record, field) => validationCell(content, oldContent, record, field, tr)"
              />
            </template>
          </vue-excel-editor>
        </template>
        <template v-else>
          <data-table
            class="mt-6"
            :table-header="tableHeadersPopulate"
            :table-data="tableData"
            :sort-by="filter.sort_by"
            :sort-dir="filter.sort_dir"
            :loading="isBusy"
            @sort="sort"
            :frozen-columns="7"
            :grouped-headers="groupHeaders"
            :expanded-rows-list="expandedRowsList"
            :is-expanded-row-keep-same-header-col="true"
            :hide-search="!tableData.length"
            :hide-page-limit-selection="!tableData.length"
            key-header-checkbox="master_checkbox"
            :is-header-checkbox-disabled="!selectedRow.length"
            :header-checkbox-default-checked="!!selectedRow.length"
            @checkAll="onHandleSelectAll"
          >
            <template
              v-if="isUserCanAccessMenu(permission.name, 'edit') || isUserCanAccessMenu(permission.name, 'delete')"
              #master_checkbox="{ row }"
            >
              <div
                v-if="isCheckboxShow(row)"
                class="flex flex-row w-min items-center gap-3"
              >
                <vs-checkbox
                  color="primary"
                  v-model="row.is_checked"
                  @input="() => onHandleSelect(row)"
                />
              </div>
            </template>
            <template #no="{ index }">
              <span>{{ (currentPage - 1) * pageSize + index + 1 }}</span>
            </template>
            <template #action="{ row }">
              <div class="flex flex-row gap-x-2 overflow-hidden">
                <template v-if="row.isEditing">
                  <div
                    :class="`flex items-center justify-center icon-transparent-bg complete ${fetchLoading.saveEdit && 'opacity-50 animate-bounce cursor-not-allowed'}`"
                    @click="saveEdit"
                  >
                    <img
                      :src="require('@/assets/shipo-icon-check-circle.svg')"
                      alt="check"
                    >
                  </div>
                  <div
                    :class="`flex items-center justify-center icon-transparent-bg delete ${fetchLoading.saveEdit && 'opacity-50 animate-bounce cursor-not-allowed'}`"
                    @click="cancelEdit(row)"
                  >
                    <img
                      :src="require('@/assets/shipo-icon-close-circle.svg')"
                      alt="close"
                    >
                  </div>
                </template>
                <template v-else>
                  <div
                    :class="`flex items-center justify-center icon-transparent-bg ${(isStartEditLoading === row.id && isReturnCargo === row.is_blu_return_cargo) && 'animate-bounce cursor-not-allowed'}`"
                    @click="onHandleShowDetail(row)"
                  >
                    <img
                      :src="require('@/assets/shipo-icon-see.svg')"
                      alt="see"
                    >
                  </div>
                  <div
                    v-if="isUserCanAccessMenu(permission.name, 'edit') && row.status.toLowerCase() !== 'completed'"
                    :class="`flex items-center justify-center icon-transparent-bg ${(isStartEditLoading === row.id && isReturnCargo === row.is_blu_return_cargo) && 'animate-bounce cursor-not-allowed'}`"
                    @click="isStartEditLoading === row.id ? null : startEdit(row)"
                  >
                    <img
                      :src="require('@/assets/shipo-icon-edit.svg')"
                      alt="edit"
                    >
                  </div>
                  <div
                    v-if="isUserCanAccessMenu(permission.name, 'add') && row.can_return_cargo"
                    :class="`flex items-center justify-center icon-transparent-bg ${isStartEditLoading === row.id && 'animate-bounce cursor-not-allowed'}`"
                    @click="onHandleReturnCargo(row)"
                  >
                    <img
                      :src="require('@/assets/shipo-icon-return-cargo.svg')"
                      alt="return"
                    >
                  </div>
                  <div
                    :class="`self-center flex items-center justify-center cursor-pointer icon-transparent-bg ${(isStartEditLoading === row.id && isReturnCargo === row.is_blu_return_cargo) && 'animate-bounce cursor-not-allowed'}`"
                    @click="isStartEditLoading === row.id ? null : toggleRow(row)"
                  >
                    <img
                      :src="
                        require(
                          expandedRowsList.includes(`${row.id}-${row.is_blu_return_cargo}`)
                            ? '@/assets/shipo-icon-arrow-up.svg'
                            : '@/assets/shipo-icon-arrow-down.svg'
                        )"
                      alt="arrow"
                    >
                  </div>
                </template>
              </div>
            </template>
            <template
              v-for="(item, index) of staticColumns"
              #[item.key]="{ row }"
            >
              <!-- Edit row -->
              <div
                v-if="row.isEditing"
                :key="`${item.key}_${index}_${row.id}`"
              >
                <div
                  v-if="item.isStatus && item.isLabel"
                  class="px-2 badge-status"
                  :style="item.key === 'doc_assignment'
                    ? generateBadgeStyle( row.editForm[item.key].value, 'doc_assignment')
                    : {}"
                >
                  {{ row.editForm[item.key].value }}
                </div>
                <div v-else-if="row.is_blu_return_cargo && item.key === 'end_user'">
                  <select-with-search
                    v-model="row.editForm.vessel_line_up_id"
                    :class="{ 'is-not-valid': !row.editForm.vessel_line_up_id }"
                    :options="editOptions.end_user"
                    placeholder="End User"
                    class="w-fit"
                    @input="(v) => onHandleEndUserChange(v, row.id, row.is_blu_return_cargo)"
                  />
                </div>
                <div v-else-if="!row.is_blu_return_cargo && item.key === 'name_of_vessel'">
                  <select-with-search
                    :name="item.key"
                    is-object-model
                    v-model="row.editForm.name_of_vessel.value"
                    :class="{ 'is-not-valid': !row.editForm.name_of_vessel.value }"
                    :options="editOptions.name_of_vessel"
                    placeholder="Name Of Vessel"
                    class="w-fit"
                    @input="(v) => onHandleNameOfVesselChange(v, row.id, row.is_blu_return_cargo)"
                  />
                </div>
                <date-picker
                  v-else-if="item.isDate"
                  confirm
                  v-model="row.editForm[item.key].value"
                  type="datetime"
                  value-type="format"
                  format="DD-MMM-YYYY HH:mm"
                  class="w-56"
                  :class="{ 'is-not-valid': isInvalidCell(row.editForm[item.key]) }"
                  :placeholder="item.placeholder"
                  :disabled="item.isDisabled || isHasCheckpointActualData(row.id, item.key, null, row.is_blu_return_cargo, false)"
                  :change="(value) => onInputChange(row.id, item.key, value, row.is_blu_return_cargo)"
                />
                <v-autonumeric
                  v-else-if="item.isFreeInput && item.isNumber"
                  v-model="row.editForm[item.key].value"
                  class="w-max autonumeric-primary w-20"
                  :class="{
                    'is-not-valid': isInvalidCell(row.editForm[item.key])
                  }"
                  :placeholder="item.placeholder"
                  :options="globalNumericOptions"
                  :disabled="item.isDisabled || (row.is_blu_return_cargo && item.key !== 'actual_quantity')"
                />
                <vs-input
                  v-else-if="(item.isLabel && item.isFreeInput) || (item.isFreeInput && !item.isNumber) || (row.is_blu_return_cargo && item.key === 'name_of_vessel')"
                  v-model="row.editForm[item.key].value"
                  class="w-40"
                  :class="{
                    'w-64': item.key === 'remark',
                    'is-not-valid': isInvalidCell(row.editForm[item.key])
                  }"
                  :placeholder="item.placeholder"
                  :disabled="populateDisabledField(row, item)"
                  :icon-after="item.key === 'capacity'"
                  :icon="item.key === 'capacity' ? '%' : ''"
                />
                <select-with-search
                  :name="item.key"
                  is-object-model
                  v-else-if="!item.isFreeInput && !Array.isArray(row.editForm[item.key].value)"
                  v-model="row.editForm[item.key].value"
                  class="w-fit"
                  :class="{
                    'is-not-valid': isInvalidCell(row.editForm[item.key], item.key === 'tug' ? 'tug' : null)
                  }"
                  :is-valid="item.isValid"
                  :options="generateOptionsByKey(item.key)"
                  :placeholder="item.placeholder"
                  :disabled="populateDisabledField(row, item)"
                  is-show-default-value
                />
              </div>
              <!-- View Row -->
              <template v-else>
                <template v-if="item.group === 'general'">
                  <div
                    :key="`${item.key}_${index}`"
                    :class="{'px-2 badge-status' : item.key === 'status' || item.key === 'activity_status' || item.key === 'doc_assignment'}"
                    :style="item.key === 'status' || item.key === 'activity_status' ? generateBadgeStyle(row.status)
                      : item.key === 'doc_assignment' ? generateBadgeStyle( row.doc_assignment, 'doc_assignment') : {}"
                  >
                    {{ populateValueOfGeneralColumn(item, row) }}
                  </div>
                </template>
                <template v-else>
                  <span
                    :key="`${item.key}_${index}_${row.id}`"
                    v-if="item.key === 'remark'"
                  >
                    {{ row[item.key] }}
                  </span>
                  <span
                    :style="{ color: isHasCheckpointActualData(row.id, item.key, null, row.is_blu_return_cargo, true) ? 'black' : '#836ADA' }"
                    :key="`${item.key}_${index}_${row.id}`"
                    v-else
                  >
                    {{ populateCheckpoints(row, item.key, item.isDate) }}
                  </span>
                </template>
              </template>
            </template>

            <!--  RENDER DYNAMIC PRODUCTS  -->
            <template
              v-for="(item, index) of generateProductSlots()"
              #[item.slot_name]="{ row }"
            >
              <!--  Edit Row  -->
              <div
                v-if="row.isEditing"
                :key="`${item.slot_name}_${index}`"
              >
                <v-autonumeric
                  class="autonumeric-primary"
                  v-model="row.editForm[item.slot_name].value"
                  :options="globalNumericOptions"
                  :placeholder="item.placeholder"
                  :disabled="row.is_blu_return_cargo"
                />
              </div>

              <!--  View Row  -->
              <div
                v-else
                :key="`${item.label}_${index}`"
              >
                <span>
                  {{
                    row[item.group] && !isEmpty(row[item.group].find((product) => product.name === item.label))
                      ? handleValidateAndFormatNumber(row[item.group].find((product) => product.name === item.label).tonnage)
                      : 0
                  }}
                </span>
              </div>
            </template>

            <!-- TEMPLATE FOR HISTORY ROW: FROZEN COLUMNS -->
            <template #detail-frozen="{ parentData }">
              <template
                v-if="parentData.histories.length === 0"
              >
                <tr class="history-row frozen">
                  <td
                    class="td"
                    style="min-width: 50px;"
                  />
                  <td class="td">
                    <div class="flex flex-row">
                      <div
                        class="flex items-center w-full justify-center"
                      >
                        <img :src="require('@/assets/shipo-icon-arrow-forward.svg')">
                      </div>
                    </div>
                  </td>
                  <td
                    :colspan="tableHeaders.filter((header) => header.freeze).length - 2"
                    class="td"
                  >
                    <div class="italic">
                      No history found for this BLU
                    </div>
                  </td>
                </tr>
              </template>
              <template
                v-else
                v-for="(history, indextr) in parentData.histories"
              >
                <tr
                  :key="`${parentData.id}_${parentData.is_blu_return_cargo}_${indextr}`"
                  class="history-row frozen"
                >
                  <td
                    class="td"
                    style="min-width: 50px;"
                  />
                  <td class="td">
                    <div class="flex flex-row">
                      <div
                        class="flex items-center w-full justify-center"
                      >
                        <img
                          :src="
                            require('@/assets/shipo-icon-arrow-forward.svg')"
                        >
                      </div>
                    </div>
                  </td>
                  <template
                    v-for="(header, indextd) in tableHeaders.filter((th) => th.freeze && th.key !== 'no' && th.key !== 'action')"
                  >
                    <td
                      :key="`${indextd}_${header.key}`"
                      class="td"
                    >
                      {{ history[header.key] }}
                    </td>
                  </template>
                </tr>
              </template>
            </template>
            <!-- TEMPLATE FOR HISTORY ROW: SCROLLABLE COLUMNS -->
            <template #detail="{ parentData }">
              <template
                v-if="parentData.histories.length === 0"
              >
                <tr class="history-row scrollable">
                  <td
                    :colspan="tableHeaders.filter((header) => !header.freeze).length"
                    class="td"
                  />
                </tr>
              </template>
              <template
                v-else
                v-for="(history, indextr) in parentData.histories"
              >
                <tr
                  :key="`${parentData.id}_${parentData.is_blu_return_cargo}_${indextr}`"
                  class="history-row scrollable"
                >
                  <template v-for="(header, indextd) in tableHeaders.filter((h) => !h.freeze)">
                    <td
                      :key="`${indextd}_${header.key}`"
                      class="td"
                    >
                      <div v-if="header.group && header.group === 'simulation'">
                        <span v-if="header.key === 'remark'">
                          {{ history[header.key] }}
                        </span>
                        <span
                          v-else
                          :style="{ color: isHasCheckpointActualData(parentData.id, header.key, history.id, parentData.is_blu_return_cargo, true) ? 'black' : '#836ADA' }"
                        >
                          {{ populateCheckpoints(history, header.key, header.isDate) }}
                        </span>
                      </div>
                      <span v-else-if="header.isDate">
                        {{ moment(history[header.key]).format('DD-MMM-YYYY HH:mm') }}
                      </span>
                      <div
                        v-else-if="header.key === 'status'"
                        class="px-2 badge-status"
                        :style="generateBadgeStyle(history.status)"
                      >
                        {{ history[header.key] ? populateStatusValue(history[header.key]).toUpperCase() : '' }}
                      </div>
                      <div
                        v-else-if="header.key === 'activity_status'"
                        class="px-2 badge-status"
                        :style="generateBadgeStyle(history.status)"
                      >
                        {{ history[header.key] || 'N/A' }}
                      </div>
                      <div
                        v-else-if="header.key === 'doc_assignment'"
                        class="px-2 badge-status"
                        :style="generateBadgeStyle(history[header.key], 'doc_assignment')"
                      >
                        {{ history[header.key] ? history[header.key].toUpperCase() : '' }}
                      </div>
                      <span v-else-if="header.isProduct">
                        {{
                          !isEmpty(history.products.find((h) => h.product_id === header.label))
                            ? handleValidateAndFormatNumber(history.products.find((h) => h.product_id === header.label).tonnage)
                            : 0
                        }}
                      </span>
                      <span v-else>
                        {{ populateValueOfGeneralColumn(header, history) }}
                      </span>
                    </td>
                  </template>
                </tr>
              </template>
            </template>
          </data-table>
          <table-bottom @fetch="fetchBarges" />
        </template>
      </div>
    </div>
    <base-custom-modal :is-shown.sync="isDelayModalShown">
      <template #title>
        <span class="font-semibold">Add Delay Time</span>
      </template>
      <template #body>
        <div class="p-5 flex flex-row rounded-lg bg-white">
          <div class="w-1/3 flex flex-col justify-center">
            <p class="mb-3 text-gray-500">
              Trip No
            </p>
            <span class="font-semibold">{{ bluDetail ? bluDetail.trip_number : 'Unknown' }}</span>
          </div>
          <div class="w-1/3 flex flex-col justify-center">
            <p class="mb-3 text-gray-500">
              Barge Name
            </p>
            <span class="font-semibold">{{ bluDetail ? bluDetail.barge : 'Unknown' }}</span>
          </div>
          <div class="w-1/3 flex flex-row items-center justify-end">
            <date-picker
              class="w-full"
              value-type="format"
              format="DD-MMM-YYYY"
              v-model="todayDate"
              :disabled="true"
              :img-size="24"
            />
          </div>
        </div>
        <upload-file
          class="my-8"
          :loading="isLoading"
          :is-browse-disabled="isDelayTimeLoading"
          @upload="uploadDelayTime"
          @preview="previewDelayTime"
        />
        <delay-time
          :is-loading="isDelayTimeLoading"
          :blu-detail="bluDetail"
          :barge-delay-time="bargeDelayTimePreview"
          @onFieldChange="onDelayTimeFieldChange"
        />
      </template>
      <template #footer>
        <vs-button
          type="border"
          color="secondary"
          class="w-32 mr-1"
          @click="isDelayModalShown = false"
        >
          Cancel
        </vs-button>
        <vs-button
          type="filled"
          color="secondary"
          class="w-32 ml-1"
          @click="submitDelayTime"
        >
          Submit
        </vs-button>
      </template>
    </base-custom-modal>
    <pop-up
      :active.sync="isPopUpShown"
      @ok="isPopUpShown = false"
      @cancel="isPopUpShown = false"
    >
      You have successfully add delay time
    </pop-up>
    <pop-up
      title="Discard Changes"
      is-warning
      :active.sync="isPopUpDiscardShown"
      left-button="Discard"
      right-button="Cancel"
      :is-title-on-top="false"
      @leftButton="cancelEditMode"
      @rightButton="()=> {
        editedItemsFromEditMode = []
        isPopUpDiscardShown = false
      }"
      @close="()=> {
        editedItemsFromEditMode = []
        isPopUpDiscardShown = false
      }"
    >
      <div class="mt-2 text-center ">
        <div>
          Are you sure you want to discard changes on {{ editedItemsFromEditMode.length }} data?
        </div>
        <span class="font-semibold">This action cannot be undone.</span>
      </div>
    </pop-up>
    <modal-detail
      :active.sync="showBluDetail"
      :blu-plan-id="bluPlanId"
      @close="() => {
        bluPlanId = null
        showBluDetail = !showBluDetail
      }"
    />
    <barge-line-up-confirmation-pop-up
      :active.sync="isConfirmationModalShown"
      :confirmation-title="confirmationModalAttributes.title"
      :confirmation-message="confirmationModalAttributes.message"
      :cancel-button-text="confirmationModalAttributes.cancelText"
      :confirmation-button-text="confirmationModalAttributes.confirmText"
      :image-url="confirmationModalAttributes.imageUrl"
      :is-reverse-button="confirmationModalAttributes.isReverseButton"
      :button-color="confirmationModalAttributes.buttonColor"
      :is-busy="fetchLoading.bulkLoading"
      @cancel="confirmationModalAttributes.cancelFunc"
      @confirm="confirmationModalAttributes.confirmFunc"
    />
    <modal-return-cargo
      :active.sync="showModalReturnCargo"
      :blu-id="bluPlanId"
      :trip-number="tripNumber"
      :is-add="isAddReturnCargo"
      @action="closeReturnCargoModal"
      @close="showModalReturnCargo = true"
    />
  </div>
</template>

<script>
import _, { cloneDeep, find, flatten, isEmpty, isPlainObject, map, uniqBy } from 'lodash'
import moment from 'moment'
import Vue from 'vue'
import { mapGetters } from 'vuex'

import BaseCustomModal from '@/components/baseCustomModal'
import DataTable from '@/components/dataTable'
import DatePicker from '@/components/datePicker'
import PopUp from '@/components/popUp'
import SelectWithMultiple from '@/components/selectWithMultiple/index.vue'
import SelectWithSearch from '@/components/selectWithSearch'
import TableBottom from '@/components/tableBottom'
import TableTop from '@/components/tableTop'
import UploadFile from '@/components/uploadFile'
import BargeLineUpColumns from '@/fixtures/barge-line-up-columns.json'
import {
  KEY_BARGE_LINE_UP_CALCULATE_UNLOADING_BERTHING_UNBERTHING,
  KEY_BARGE_LINE_UP_PRODUCT_DICTIONARY,
  PAGE_TITLE
} from '@/fixtures/Constants'
import downloadUtils from '@/utils/downloadUtils'
import BargeLineUpConfirmationPopUp from '@/views/bargeLineUp/list/ModalConfirmation.vue'

import DelayTime from '../delayTime'
import ModalDetail from './ModalDetail.vue'
import ModalReturnCargo from './ModalReturnCargo.vue'

Vue.directive('fix-scroll', {
  inserted(el) {
    const container = el.querySelector('.autocomplete-results')
    if (!container) return

    const observer = new MutationObserver(() => {
      if (window.getComputedStyle(container).display === 'none') {
        return
      }
      requestAnimationFrame(() => {
        const selected = container.querySelector('.autocomplete-result.select')
        if (selected) {
          container.scrollTop = selected.offsetTop - container.clientHeight / 2
        }
      })
    })

    observer.observe(container, { childList: true, subtree: true, attributes: true })
  }
})

export default {
  metaInfo: {
    title: `${PAGE_TITLE} List Barge Line Up`
  },
  components: {
    BargeLineUpConfirmationPopUp,
    SelectWithMultiple,
    SelectWithSearch,
    DataTable,
    TableTop,
    TableBottom,
    DatePicker,
    BaseCustomModal,
    DelayTime,
    PopUp,
    UploadFile,
    ModalDetail,
    ModalReturnCargo
  },
  data() {
    const COMPANY_BACKGROUND_COLOR = {
      TCM: '#FEF3F0',
      BEK: '#D1F9E3',
      JBG: '#E0F7FA',
      EMB: '#FFDDE1',
      IMM: '#F0E6F6',
      THIRD_PARTY: '#FFF9DB'
    }

    const DOC_ASSIGNMENT_COLOR = {
      PLAN: {
        background: '#5382FB33',
        color: '#5382FB'
      },
      NOT_ASSIGNED: {
        background: '#B01E4733',
        color: '#B01E47'
      },
      ASSIGNED: {
        background: '#00cc6940',
        color: '#00cc69'
      }
    }

    const groupHeaders = BargeLineUpColumns.companies.map((company) => ({
      key: company.key,
      title: company.title,
      startColumn: company.products[0].key,
      endColumn: company.products[company.products.length - 1].key,
      backgroundColor: COMPANY_BACKGROUND_COLOR[company.key.toUpperCase()]
    }))

    groupHeaders.push({
      key: 'third_party',
      title: '3rd Party',
      startColumn: null,
      endColumn: null,
      backgroundColor: COMPANY_BACKGROUND_COLOR['THIRD_PARTY']
    })

    return {
      DOC_ASSIGNMENT: [
        { value: 'PLAN', text: 'PLAN' },
        { value: 'NOT_ASSIGNED', text: 'NOT_ASSIGNED' },
        { value: 'ASSIGNED', text: 'ASSIGNED' }
      ],
      TRADE_OPTIONS: [
        {value: 'EXPORT', text: 'EXPORT'},
        {value: 'DOMESTIC', text: 'DOMESTIC'}
      ],
      isDelayModalShown: false,
      isPopUpShown: false,
      isPopUpDiscardShown: false,
      isLoading: false,
      isOnDropdownDataFetch: false,
      isDelayTimeLoading: false,
      isStartEditLoading: false,
      isReturnCargo: null,
      isConfirmationModalShown: false,
      confirmationModalAttributes:{
        title: '',
        message: '',
        cancelText: 'No',
        confirmText: 'Yes',
        cancelFunc: () => {},
        confirmFunc: () => {},
        isReverseButton: false,
        buttonColor: '',
        imageUrl: ''
      },
      isEditMode: false,
      todayDate: moment().format('DD-MMM-YYYY'),
      isBusy: false,
      // key written to match BE filter key
      filter: {
        name_of_vessel: [],
        barge: [],
        route: [],
        sort_by: null,
        sort_dir: null,
        date: [moment().format('MMM-YYYY'), moment().format('MMM-YYYY')],
        doc_assignment: [],
        product_id: []
      },
      tableHeaders: [
        { key: 'master_checkbox', label: 'checkbox', freeze: true },
        { key: 'no', label: 'No', freeze: true },
        { key: 'action', label: 'Action', freeze: true },
        ...BargeLineUpColumns.general.map(generalForm => ({
          ...generalForm,
          group: 'general',
          freeze: generalForm.freeze || false,
          isNumber: generalForm.isNumber || false
        })),
        ...BargeLineUpColumns.simulation.map(simulationForm => ({
          ...simulationForm,
          group: 'simulation',
          freeze: simulationForm.freeze || false,
          isNumber: simulationForm.isNumber || false
        }))
      ],
      groupHeaders: groupHeaders,
      tableData: [],
      tableDataForExcel: [],
      editedItemsFromEditMode: [],
      doc_assignment: [],
      vesselOptions: [],
      bargeOptions: [],
      routeOptions: [],
      termOptions: [],
      tugOptions: [],
      productIdOptions: [],
      productVesselIdOptions: [],
      podOptions: [],
      polOptions: [],
      kpiOptions: [],
      bulkEditErrors: [],
      selectedRow:[],
      bluDetail: null,
      bargeDelayTimePreview: {
        filename: null,
        total_hours: 0
      },
      delayTime: null,
      formGeneral: BargeLineUpColumns.general,
      formCompanies: BargeLineUpColumns.companies,
      formPlan: BargeLineUpColumns.simulation,
      expandedRowsList: [],
      historyRowData: [],
      docAssignmentColor: DOC_ASSIGNMENT_COLOR,
      productKey: {},
      isDownload: false,
      isProductIdEditFirstFetch: true,
      isBulkEditProcessing: false,
      currentVluId: null,
      editOptions: {
        barge: [],
        tug: [],
        shipper: [],
        POD: [],
        POL: [],
        status: [],
        doc_assignment: [],
        activity_status: [],
        end_user: [],
        name_of_vessel: []
      },
      defaultSearch: null,
      showBluDetail: false,
      bluPlanId: null,
      showModalReturnCargo: false,
      isAddReturnCargo: false,
      tripNumber: null,
      fetchLoading: {
        bulkLoading: false,
        vesselOptions: false,
        bargeOptions: false,
        routeOptions: false,
        productOptions: false,
        exportBLU: {
          BO: false,
          BLU: false,
          BLUV2: false
        },
        saveEdit: false
      },
      isSendEmail: false
    }
  },
  async created() {
    if (this.routeHasParams) {
      const bluId = this.$route?.params?.blu_id
      await this.fetchBargeDetail(bluId)
    }
  },
  async mounted() {
    await Promise.all([
      this.editOptions.status = await this.fetchDropdownByType( 'TRIP_STATUS'),
      this.fetchRouteItems(),
      this.fetchProductItems(),
      this.fetchOptionsOnCreate()
    ])

    if (this.$route.query.filter) {
      this.filter.name_of_vessel = this.$route.query.filter.name_of_vessel
    }
  },
  computed: {
    ...mapGetters({
      currentPage: 'Table/currentPage',
      pageSize: 'Table/pageSize',
      fileName: 'UploadFile/fileName',
      barges: 'BargeLineUp/barges',
      bargeDelayTime: 'BargeLineUp/bargeDelayTime',
      latestDelayTime: 'BargeLineUp/latestBargeDelayTime',
      vesselItems: 'BargeLineUp/vesselItems',
      bargeItems: 'BargeManagement/bargeManagements',
      termItems: 'BargeLineUp/termItems',
      tugItems: 'BargeLineUp/tugItems',
      productIdItems: 'BargeLineUp/productIdItems',
      routeItems: 'BargeLineUp/routeItems',
      productItems: 'BargeLineUp/productItems',
      latestPol: 'BargeLineUp/latestPol',
      latestPod: 'BargeLineUp/latestPod',
      bargeLineUpsFiles: 'BargeLineUp/bargeLineUpsFiles',
      bargeDetail: 'BargeLineUp/bargeDetail',
      vesselLineUpDetail: 'VesselLineUp/vesselLineUpDetail',
      bargeEditOptions: 'BargeLineUp/bargeEditOptions',
      tugEditOptions: 'BargeLineUp/tugEditOptions',
      locations: 'LocationManagement/locations',
      dropdownOptions: 'BargeLineUp/dropdownOptionsBLU',
      polItems: 'BargeLineUp/polItems',
      podItems: 'BargeLineUp/podItems',
      calculatedSimulation: 'BargeLineUp/calculatedSimulation',
      activityStatusOptions: 'KeyActivityStatus/activityStatusByTripStatus'
    }),
    permission() {
      return { page: this.$route.meta.permission.page, name: this.$route.meta.permission.name }
    },
    statusOptions() {
      return [...this.editOptions.status]
    },
    staticColumns() {
      return this.tableHeaders
        .filter(({ key, group }) => key !== 'no' && key !== 'action' && (group === 'general' || group === 'simulation'))
    },
    currentActiveRow() {
      return this.tableData.find(row => row?.isEditing)
    },
    clonedCurrentActiveRow() {
      // Needed specifically to watch fields related to product tonnage changes
      return cloneDeep(this.tableData.find(row => row?.isEditing))
    },
    routeHasParams() {
      return !!this.$route?.params?.blu_id
    },
    modalExportPosition() {
      const el = this.$refs.buttonExport?.$el || this.$refs.buttonExport
      if (!el) {
        return { top: 0, left: 0 }
      }

      const { offsetTop, offsetLeft, offsetHeight } = el
      return {
        top: offsetTop + offsetHeight,
        left: offsetLeft
      };
    },
    tableHeadersExcel() {
      return this.tableHeaders.filter(item => item.key !== 'action' && item.key !== 'no' && item.key !== 'master_checkbox').map(v => {
        if (v.key === 'end_user') {
          return {
            ...v,
            isDisabled: false,
            isFreeInput: false
          }
        }
        return v
      })
    },
    tableHeadersPopulate() {
      const display = this.tableHeaders.filter((header) => {
        if(!this.isUserCanAccessMenu(this.permission.name, 'edit') && !this.isUserCanAccessMenu(this.permission.name, 'delete')) {
          return header.key !== 'master_checkbox'
        }
        return header
      })
      return display
    }
  },
  watch: {
    barges: {
      immediate: true,
      handler(val) {
        if (!this.isEmpty(val)) {
          // set tableHeaders & groupHeader to default data
          this.tableHeaders = this.$options.data().tableHeaders
          this.groupHeader = this.$options.data().groupHeader
          this.tableData = val.map((item) => ({
            ...item,
            product_id: typeof item.product_id === 'string' ?  item.product_id : item.product_id.length > 1 ? item.product_id.join(',') : item.product_id[0],
            shipper_name: item.shipper ? item.shipper.name : '',
            histories: [],
            is_checked: this.selectedRow.includes(item.id),
            expandedRef: `${item.id}-${item.is_blu_return_cargo}`
          }))

          this.populateDynamicData()
          const headerDates = this.tableHeaders.filter(item => item.isDate)
          const excelData = val
            .filter(v => v.status !== 'COMPLETED')
            .map((item) => this.prepareExcelItem(item, headerDates))

          const plainTableHeaders = [...this.tableHeaders].map(th => ({ [th.key]: th.isNumber || th.isProduct ? 0 : null }))

          //Get all property of the data
          const dataFromHeaders = Object.assign({}, ..._.flatten(plainTableHeaders))
          const keys = Object.keys(dataFromHeaders)

          //Put default value for every data based on header
          if(excelData.length) {
            this.tableDataForExcel = excelData.map(obj => {
              const newObj = {dataID: obj.dataID}
              keys.forEach(key => {
                const choosedHeader = this.tableHeaders.find(p => p.key === key)
                newObj[key] = obj[key] ? obj[key] : choosedHeader.isNumber || choosedHeader.isProduct ? 0 : null
              })
              return {
                ...newObj,
                vessel_line_up_id: obj.vessel_line_up_id,
                is_blu_return_cargo: obj.is_blu_return_cargo
              }
            })
          } else {
            this.tableDataForExcel = []
          }
        } else {
          this.tableData = val
          this.tableDataForExcel = val
        }
      }
    },
    fileName: {
      handler(val) {
        this.bargeDelayTimePreview = { ...this.bargeDelayTimePreview, filename: val }
      }
    },
    bargeDelayTime: {
      handler(val) {
        const serviceTripItem = val.find(item => item.service_trips === this.bluDetail.trip_number)

        if (serviceTripItem) {
          this.bargeDelayTimePreview = { ...this.bargeDelayTimePreview, ...serviceTripItem }
        }
      }
    },
    latestDelayTime: {
      handler(val) {
        if (val) {
          this.bargeDelayTimePreview = { ...this.bargeDelayTimePreview, ...val }
        }
      }
    },
    vesselItems: {
      immediate: true,
      handler(val) {
        this.vesselOptions = val.map(item => ({ value: item.name, text: item.name }))
      }
    },
    currentActiveRow: {
      immediate: true,
      async handler(val) {
        if (val) {
          this.countActualQty()

          this.currentVluId = val?.vessel_line_up_id
          if (!!this.currentVluId) {
            await this.fetchProductIdItems(this.currentVluId)
            await this.getVesselLineUp()
          }
        }
      }
    },
    'currentActiveRow.editForm.pol': {
      deep: true,
      async handler(val) {
        if (val) {
          this.getRoute()
          await this.fetchLatestPol(val?.value?.text)
        }
      }
    },
    'currentActiveRow.editForm.pod': {
      deep: true,
      async handler(val) {
        if (!val) return

        this.getRoute()
        const { name_of_vessel } = this.currentActiveRow
        await this.fetchLatestPod(val?.value?.text, name_of_vessel)
      }
    },
    'currentActiveRow.editForm.term':{
      deep: true,
      async handler(val) {
        if (!val) return

        if(val && val?.value?.text) {
          this.editOptions.tug =  await this.fetchDropdownByType('TUG', val?.value?.text)
          this.editOptions.barge = await this.fetchDropdownByType('BARGE', val?.value?.text)
          const isTugCanBeFoundInOptions = this.editOptions.tug.some(item=> item.text === this.currentActiveRow.editForm.tug.value.value)
          const isBargeCanBeFoundInOptions = this.editOptions.barge.some(item=> item.text === this.currentActiveRow.editForm.barge.value.value)
          if(!isTugCanBeFoundInOptions) {
            this.currentActiveRow.editForm.tug.value = null
          }
          if(!isBargeCanBeFoundInOptions) {
            this.currentActiveRow.editForm.barge.value = null
          }
        }
      }
    },
    'currentActiveRow.editForm.arrive_smds':{
      deep: true,
      handler(val) {
        if (!val) return

        this.currentActiveRow.editForm.trip_start.value = val.value
        const tripEnd = this.currentActiveRow.editForm.trip_end.value
        if(moment(val.value, 'DD-MMM-YYYY hh:mm').isValid() && moment(tripEnd, 'DD-MMM-YYYY hh:mm').isValid()) {
          this.currentActiveRow.editForm.barge_cycle.value = moment(tripEnd).diff(moment(val.value),'days')
        }
      }
    },
    'currentActiveRow.editForm.arrive_smdr':{
      deep: true,
      handler(val) {
        if (!val) return

        this.currentActiveRow.editForm.trip_end.value = val.value
        const tripStart = this.currentActiveRow.editForm.trip_start.value
        if(moment(val.value, 'DD-MMM-YYYY hh:mm').isValid() && moment(tripStart, 'DD-MMM-YYYY hh:mm').isValid()) {
          this.currentActiveRow.editForm.barge_cycle.value = moment(val.value).diff(moment(tripStart),'days')
        }
      }
    },
    'currentActiveRow.editForm.tug': {
      deep: true,
      handler(val) {
        if (!val || this.currentActiveRow?.editForm?.term?.value?.text === 'SPOT') return
        const selectedBarge = this.editOptions.barge.find(b => b.tug === val.value.text)
        this.currentActiveRow.editForm.barge.value = !isEmpty(selectedBarge) ? selectedBarge : null
      }
    },
    'currentActiveRow.editForm.barge': {
      deep: true,
      handler(val) {
        if (!val || this.currentActiveRow?.editForm?.term?.value?.text === 'SPOT') return
        const selectedTug = this.editOptions.tug.find(b => b.barge === val.value.text)
        this.currentActiveRow.editForm.tug.value = !isEmpty(selectedTug) ? selectedTug : null
      }
    },
    'currentActiveRow.editForm.trip_number': {
      deep: true,
      handler(val) {
        if (!val) return
        const allTripNumber = this.tableData.map(item => item.trip_number).filter(item => this.currentActiveRow.trip_number !== item)
        val.isError = allTripNumber.includes(val.value);
      }
    },
    'currentActiveRow.editForm.status': {
      deep: true,
      async handler(val) {
        if(!val) {
          return
        }
        if (!val.value) {
          this.currentActiveRow.editForm.activity_status.value = null
          return
        }
        let selectedId = val.value.id
        if(val.value.value === 'COMPLETED') {
          selectedId = this.editOptions.status.find(item => item.value === 'HOME' || item.text === 'HOME').id
        }
        if(selectedId) {
          await this.fetchActivityStatusByTripStatus(selectedId)
          this.editOptions.activity_status = this.activityStatusOptions.map(item => ({ value: item.name, text: item.name, id: item.id }))
        } else {
          this.editOptions.activity_status = []
        }
        if(val.value.value !== this.currentActiveRow.status && val.value.text !== this.currentActiveRow.status) {
          this.currentActiveRow.editForm.activity_status.value = null
        }
      }
    },
    clonedCurrentActiveRow: {
      deep: true,
      handler(val, oldVal) {
        if (val && oldVal) {
          const latestForm = val?.editForm
          const oldForm = oldVal?.editForm
          const keyChanges = Object.keys(latestForm).find(key => !_.isEqual(latestForm[key], oldForm[key]))
          this.syncProductTonnage(keyChanges, latestForm, oldForm)
        }
      }
    },
    bargeItems: {
      immediate: true,
      handler(val) {
        this.bargeOptions = map(val, function(o) {
          return {
            value: o.name,
            text: o.name,
            id: o.id
          }
        })
      }
    },
    termItems: {
      handler(val) {
        // There are `id` with `null` value, search isn't functional if there are `null` value
        this.termOptions = val.map(item => ({ value: item.id, text: item.name }))
          .filter(item => item.value)
      }
    },
    tugItems: {
      handler(val) {
        // There are `id` with `null` value, search isn't functional if there are `null` value
        this.tugOptions = val.map(item => ({ value: item.id, text: item.name, id: item.id }))
          .filter(item => item.value)
      }
    },
    productIdItems: {
      handler(val) {
        // There are `id` with `null` value, search isn't functional if there are `null` value
        const productList = Array.isArray(val)
          ? val
          : Array.isArray(val?.data)
            ? val?.data
            : []
        const parsedProductList = productList.map((item) => this.getProductIdOriginalName(item))
        this.productVesselIdOptions = parsedProductList
          .map(item => {
            const text = item?.blending_scheme
              ? `${item.product} - ${item.blending_scheme}`
              : item?.originalName !== null
                ? item?.originalName
                : item.product
            return {
              value: item.id,
              text: text,
              product: item.product
            }
          })
          .filter(item => item.value)

        if (this.currentActiveRow) {
          this.isProductIdEditFirstFetch = true
        }
      }
    },
    routeItems: {
      handler(val) {
        this.routeOptions = uniqBy(val, 'route').map(item => ({ value: item.route, text: item.route }))
      }
    },
    productItems: {
      handler(val) {
        this.productIdOptions = val
          .map(item => {
            const text = item?.blending_scheme ? `${item.product} - ${item.blending_scheme}` : item.name_display
            return {
              value: item?.name_display || item.id,
              text: text,
              product: item?.product || item?.name_display
            }
          })
      }
    },
    bargeLineUpsFiles: {
      handler(val) {
        if (!this.isEmpty(val)) {
          const disposition = val?.headers['content-disposition']
          if(disposition) {
            const fileNameMatch = disposition.match(/filename="?([^"]+)"?/);
            if(fileNameMatch.length >= 1) {
              downloadUtils(val,`${fileNameMatch[1]}.xlsx`)
            }
          }
          // Reset the companiesFiles state
          this.$store.dispatch('BargeLineUp/resetBargeLineUpsFiles')
        }
      }
    },
    filter: {
      handler() {
        this.fetchBarges()
      },
      deep: true
    },
    bargeEditOptions: {
      handler(val) {
        this.editOptions.barge = val.map(item => ({ value: item.name, text: item.name, id: item.id }))
      }
    },
    tugEditOptions: {
      handler(val) {
        this.editOptions.tug = val.map(item => ({ value: item.id, text: item.name, id: item.id }))
      }
    },
    locations: {
      handler(val) {
        if (val) {
          const activeLocations = val.filter(({ is_active }) => is_active)

          this.polOptions = activeLocations
            .filter(({ type_port }) => type_port.toLowerCase() === 'pol')
            .map(item => ({ value: item.id, text: item.name }))

          this.podOptions = activeLocations
            .filter(({ type_port }) => type_port.toLowerCase() === 'pod')
            .map(item => ({ value: item.id, text: item.name }))
        }
      }
    },
    bargeDetail: {
      async handler(val) {
        if (val) {
          if (this.routeHasParams && !this.currentActiveRow) {
            this.filter.name_of_vessel = val.name_of_vessel
            this.filter.barge = val.barge
            this.defaultSearch = val.trip_number
            this.$store.commit(`Table/SET_SEARCH`, val.trip_number)
            await this.fetchBarges()
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     * Prepares and formats an Excel item by processing various fields of the provided item object.
     * Also includes additional data manipulations like date formatting and status population.
     *
     * @param {Object} item - The item object to be prepared. This object may contain fields such as water_level, position,
     *                        activity_status, product_id, shipper_name, blu_tonnage_per_products, and barge_plan_actual.
     * @param {Array} headerDates - An array of header date objects, where each object contains a `key` property
     *                              representing the field in the item object to be formatted as a date.
     * @return {Object} The prepared and formatted item object with additional computed fields.
     */
    prepareExcelItem(item, headerDates)  {
      const finalItem = {
        ...item,
        dataID: item.id,
        water_level: isEmpty(item.water_level) ? 0 : item.water_level,
        position: isEmpty(item.position) ? 'N/A' : item.position,
        activity_status: isEmpty(item.activity_status) ? 'N/A' : item.activity_status,
        product_id: !isEmpty(item.product_id)
          ? (typeof item.product_id === 'string' ? item.product_id : item.product_id.join(', '))
          : item.product_id,
        shipper_name: !isEmpty(item.shipper) ? (item.shipper.name || '') : (item.shipper_name || ''),
        is_blu_return_cargo: item.is_blu_return_cargo
      }

      if (item.blu_tonnage_per_products) {
        item.blu_tonnage_per_products.forEach(ib => {
          const prefix = ib.type !== 'THIRD_PARTY' ? ib.company_code : ib.type
          finalItem[`${prefix.toLowerCase()}_${ib.product_id}`] = ib.tonnage || 0
        })
      }

      if (!isEmpty(item.barge_plan_actual)) {
        Object.assign(finalItem, item.barge_plan_actual)
      }

      if (finalItem.status && this.statusOptions.length) {
        finalItem.status = this.populateStatusValue(finalItem.status)
      }

      headerDates.forEach(hD => {
        finalItem[hD.key] = finalItem[hD.key]
          ? moment(new Date(finalItem[hD.key])).format('DD-MMM-YYYY hh:mm')
          : null
      })

      finalItem.history = []
      return finalItem
    },
    isDisabledDeleteButton() {
      if(this.selectedRow.length) {
        const selectedDocStatus = this.tableData.find(item => this.selectedRow.includes(item.id))?.doc_assignment
        return selectedDocStatus !== 'PLAN';
      }
      return true
    },
    /**
     * Resets the confirmation modal to its default state by hiding it,
     * resetting its attributes, and clearing the selected rows.
     *
     * @return {void} This method does not return any value.
     */
    resetConfirmationModal() {
      this.isConfirmationModalShown = false
      this.confirmationModalAttributes = {
        title: '',
        message: '',
        cancelText: 'Yes',
        confirmText: 'No',
        cancelFunc: () => {},
        confirmFunc: () => {},
        imageUrl: '',
        buttonColor: '',
        isReverseButton: false
      }
      this.selectedRow = []
    },
    /**
     * Handles bulk assignment of barge line-ups by dispatching the relevant Vuex action,
     * displaying a success notification, resetting the confirmation modal, and re-fetching the data.
     * If an error occurs, displays a failure notification with an appropriate message.
     *
     * @return {Promise<void>} Resolves when all operations in the method are completed. Rejects if
     * an error occurs during the process.
     */
    async bulkAssign() {
      this.fetchLoading.bulkLoading = true
      try {
        await this.$store.dispatch('BargeLineUp/putBulkAssignBargeLineUp', this.selectedRow)
        this.showSuccessNotification(this, 'Successfully saved changes')
        this.resetConfirmationModal()
        await this.fetchBarges()
      } catch (error) {
        const errorMessage = error?.data?.error?.message || 'Failed to bulk assign BLU, please try again'
        this.showFailedNotification(this, errorMessage)
      } finally {
        this.fetchLoading.bulkLoading = false
      }
    },
    /**
     * Deletes multiple selected barge line-up records in bulk based on the currently selected rows.
     * The method dispatches an action to delete the selected records, shows a success notification upon success,
     * resets the confirmation modal, and refetches the updated barge data.
     * In case of an error, it displays a failure notification with an error message.
     *
     * @return {Promise<void>} A promise that resolves when the bulk delete operation is completed.
     */
    async bulkDelete() {
      this.fetchLoading.bulkLoading = true
      try {
        await this.$store.dispatch('BargeLineUp/deleteBulkDeleteBargeLineUp', this.selectedRow)
        this.showSuccessNotification(this, 'Successfully delete Barge Line Up')
        this.resetConfirmationModal()
        await this.fetchBarges()
      } catch (error) {
        const errorMessage = error?.error?.message || 'Failed to bulk delete BLU, please try again'
        this.showFailedNotification(this, errorMessage)
      } finally {
        this.fetchLoading.bulkLoading = false
      }
    },
    submitBulkAssign() {
      const selectedDocStatus = this.tableData.find(item => this.selectedRow.includes(item.id))?.doc_assignment
      if(selectedDocStatus) {
        const nextStatus = selectedDocStatus === 'PLAN' ? 'NOT ASSIGNED' : 'ASSIGNED'
        this.confirmationModalAttributes = {
          title: 'Assign BLU',
          message: `This will update ${this.selectedRow.length} BLUs Doc. Status <br> from <b>${selectedDocStatus}</b> to <b>${nextStatus}</b>. <br> This action cannot be undone.`,
          cancelText: 'Cancel',
          confirmText: 'Assign BLU',
          cancelFunc: () => this.isConfirmationModalShown = false,
          confirmFunc: async () => await this.bulkAssign()
        }
        this.isConfirmationModalShown = true
      }
    },
    /**
     * Triggers a bulk delete confirmation modal with a custom message and options.
     * The modal allows users to confirm or cancel the bulk delete operation for selected items.
     *
     * @return {void} This method does not return a value.
     */
    submitBulkDelete() {
      this.confirmationModalAttributes = {
        title: 'Delete BLU',
        message: `Are you sure you want to delete <b>${this.selectedRow.length} BLUs</b>? <br> This action cannot be undone`,
        cancelText: 'Cancel',
        confirmText: 'Delete',
        cancelFunc: () => this.isConfirmationModalShown = false,
        confirmFunc: async () => await this.bulkDelete(),
        buttonColor: '#B01E47',
        imageUrl: require('@/assets/shipo-popup-icon-terminate.svg'),
        isReverseButton: true
      }
      this.isConfirmationModalShown = true
    },
    isCheckboxShow(row) {
      return row.doc_assignment !== 'ASSIGNED' && !row.is_blu_return_cargo
    },
    onHandleSelectAll() {
      this.selectedRow = []
      this.tableData = this.tableData.map(item => ({ ...item, is_checked: false }))
    },
    onHandleSelect(row) {
      const selectedTableData = this.tableData.find(item => item.id === row.id)
      if(this.selectedRow.includes(row.id)) {
        this.selectedRow = this.selectedRow.filter(item => item !== row.id)
        selectedTableData.is_checked = false
      } else {
        if(this.selectedRow.length) {
          const selectedData = this.tableData.find(item => item.id === this.selectedRow[0])
          if(selectedData && selectedData.doc_assignment !== row.doc_assignment) {
            this.$nextTick(() => {
              selectedTableData.is_checked = false
              this.showFailedNotification(this, 'Select only trip with the same doc. status for bulk assign.')
            })
            return
          }
        }
        this.selectedRow.push(row.id)
        selectedTableData.is_checked = true
      }
    },
    populateCheckpoints(row, key, isDate) {
      let selectedCheckpoint = null
      if(row.checkpoint_actual && row.checkpoint_actual[key]) {
        selectedCheckpoint = row.checkpoint_actual[key]
      } else if(row.checkpoint_simulation && row.checkpoint_simulation[key]) {
        selectedCheckpoint = row.checkpoint_simulation[key]
      } else {
        return '-'
      }
      if(isDate) return moment(new Date(selectedCheckpoint)).format('DD-MMM-YYYY HH:mm')
      return parseInt(selectedCheckpoint)
    },
    isHasCheckpointActualData(id, key, historyId, is_blu_return_cargo, is_color) {
      if (is_blu_return_cargo && !is_color) {
        if (key === 'loading_date') return true
      }
      const selectedData = this.tableData.find(item => item.id === id && item.is_blu_return_cargo === is_blu_return_cargo)
      if(selectedData) {
        if(historyId && selectedData.histories) {
          const selectedHistory = selectedData.histories.find(item => item.id === historyId)
          if(selectedHistory && selectedHistory.checkpoint_actual) {
            return !!(selectedHistory.checkpoint_actual.hasOwnProperty(key) && selectedHistory.checkpoint_actual[key]);
          }
        }
        if(selectedData.checkpoint_actual) {
          return !!(selectedData.checkpoint_actual.hasOwnProperty(key) && selectedData.checkpoint_actual[key]);
        }
      }
      return false
    },
    async onInputChange(id, key, value, is_blu_return_cargo) {
      if(BargeLineUpColumns.simulation.map(item => item.key ).includes(key)) {
        await this.fetchCalculatedSimulation(id, is_blu_return_cargo, {[`${key}`]: value ? new Date(value): null})
        const selectedData = this.tableData.find(item => item.id === id)
        const index = this.tableData.findIndex(item => item.id === id)
        Object.keys(this.calculatedSimulation).forEach(key => {
          selectedData.editForm[key].value = this.validateAndFormatDate(this.calculatedSimulation[key])
        })
        this.$set(this.tableData[index], 'editForm', selectedData.editForm)
      }
    },
    async fetchCalculatedSimulation(id, is_blu_return_cargo, data) {
      try {
        await this.$store.dispatch('BargeLineUp/postCalculatedSimulation', { id, is_blu_return_cargo, data })
      } catch (err){
        const errorMessage = error?.error?.message || 'Failed to recalculate data, please try again'
        this.showFailedNotification(this, errorMessage)
      }
    },
    populateStatusValue(status) {
      const selectedStatus = this.statusOptions.find(item => item.value.toLowerCase() === status.toLowerCase() || item.text.toLowerCase() === status.toLowerCase())
      if(selectedStatus) {
        return selectedStatus.text
      }
      return '-'
    },
    populateValueOfGeneralColumn(column, data) {
      switch (true){
        case column.isDate:
          return this.validateAndFormatDate(data[column.key])
        case column.key === 'capacity':
          return `${parseInt((data['actual_quantity'] / data['cargo_demand'] * 100).toFixed()) || 0}%`
        case !isNaN(data[column.key]) && !data[column.key] === null:
          return this.handleValidateAndFormatNumber(data[column.key])
        case column.key === 'position':
          return data[column.key] || 'N/A'
        case column.key === 'status':
          return this.populateStatusValue(data[column.key]).toUpperCase()
        case column.key === 'activity_status':
          return data[column.key] ? data[column.key].toUpperCase() : 'N/A'
        default:
          return data[column.key]
      }
    },
    populateDisabledField(row, item) {
      if (row.is_blu_return_cargo) {
        return item.key !== 'end_user'
      }
      if((item.key === 'position' || item.key === 'status') && row.doc_assignment === 'PLAN') {
        return true
      }
      if((item.key === 'tug' || item.key === 'barge') && row.doc_assignment !== 'PLAN') {
        return true
      }
      return item.isDisabled
    },
    isCellNotDropdown(header) {
      return !!(header.isFreeInput || header.isNumber || header.isDate || header.isProduct);
    },
    /**
     * Populates the document assignment options based on the provided column data.
     *
     * @param {Object} col - The column data containing information about tug, barge, and dataID.
     *                       The `tug` and `barge` properties are used to find the corresponding IDs,
     *                       and `dataID` is used for fetching the dropdown options.
     * @return {Promise<Array<string>>} A promise that resolves to an array of strings representing the text values of the fetched options.
     */
    async populateDocAssignmentOptions(col) {
      const tugId = this.editOptions.tug.find(t => t.text === col.tug)?.id || null
      const bargeId = this.editOptions.barge.find(t => t.text === col.barge)?.id || null
      const options = await this.fetchDropdownByType('DOC_ASSIGNMENT', null, col.dataID, tugId, bargeId)
      this.editOptions.doc_assignment = options
      return options.map(opt => opt.text)
    },
    /**
     * Populates the activity status options based on the provided column's status.
     *
     * @param {Object} col - The column object containing a status property.
     * @param {string} col.status - The current status of the column, used to determine the lookup status.
     * @return {Promise<string[]>} A promise that resolves to an array of activity status option names, or an empty array if no matching status is found.
     */
    async populateActivityStatusOptions(col) {
      const lookupStatus = col.status === 'COMPLETED' ? 'HOME' : col.status
      const selectedStatus = this.editOptions.status.find(item => item.text === lookupStatus || item.value === lookupStatus)

      if (selectedStatus?.id) {
        await this.fetchActivityStatusByTripStatus(selectedStatus.id)
        return this.activityStatusOptions.map(opt => opt.name)
      }
      return []
    },
    /**
     * Populates options for a dropdown or selection list based on the given column and header values.
     * This method fetches or processes data based on specific keys in the header.
     *
     * @param {Object} col - The column object containing relevant data such as `term`.
     * @param {Object} header - The header object containing the key and other related information.
     *                          The `key` property determines which options to populate.
     * @return {Promise<Array<string>>} A promise that resolves to an array of text values for the dropdown or selection list options.
     */
    async populateOptions(col, header) {
      const term = header.key === 'tug' || header.key === 'barge' ? col.term : null
      let options = null
      switch (header.key) {
        case 'doc_assignment':
          return this.populateDocAssignmentOptions(col)
        case 'tug':
        case 'barge':
        case 'pod':
        case 'pol':
          options = await this.fetchDropdownByType(header.key.toUpperCase(), term === 'STTC'? 'TC': term)
          this.editOptions[header.key] = options
          return options.map(opt => opt.text)
        case 'shipper_name':
          options = await this.fetchDropdownByType('SHIPPER', term === 'STTC'? 'TC': term)
          this.editOptions.shipper = options
          return options.map(opt => opt.text)
        case 'status':
          return this.statusOptions.map(opt => opt.text)
        case 'term':
          return this.termOptions.map(opt => opt.text)
        case 'trade_type':
          return this.TRADE_OPTIONS.map(opt => opt.text)
        case 'activity_status':
          return this.populateActivityStatusOptions(col)
        case 'name_of_vessel':
          options = await this.fetchDropdownByType('MAIN_CARGO_VLU', null, col.dataID)
          this.editOptions.name_of_vessel = options
          return !col.is_blu_return_cargo ? options.map(opt => opt.text) : []
        case 'end_user':
          options = await this.fetchDropdownByType('RETURN_CARGO_VLU', null, col.dataID)
          this.editOptions.end_user = options
          return col.is_blu_return_cargo ? options.map(opt => opt.text) : []
        default:
          return []
      }
    },
    validationCell(content, oldContent, record, field, column) {
      const selectedOptions = this.generateOptionsByKey(field.name)
      const selectedRecord = this.tableDataForExcel.find(item => item.dataID === record.dataID && item.is_blu_return_cargo === record.is_blu_return_cargo)
      const selectedTableData = this.tableData.find(item => item.id === record.dataID)
      if (record.is_blu_return_cargo) {
        const productTonnage = flatten(this.tableData.map(td => td.hasOwnProperty('blu_tonnage_per_products') ? td.blu_tonnage_per_products: null)).filter(f => f)
        const disableFields = [
          'tug',
          'barge',
          'loading_date',
          'status',
          'activity_status',
          'doc_assignment',
          'position',
          'max_cargo',
          'gt_barge',
          'pol',
          'shipper_name',
          'pod',
          'trade_type',
          'trip_number',
          'product_id',
          'cargo_demand',
          'term',
          'remark',
          'remaining_tonnage',
          'name_of_vessel',
          ...productTonnage.map(v => `${v.company_code.toLowerCase()}_${v.product_id}`)
        ]
        if (disableFields.includes(field.name)) {
          record[field.name] = oldContent
          switch (field.name) {
            case 'tug':
              record.barge = selectedTableData.barge
              break;
            case 'barge':
              record.tug = selectedTableData.tug
              break;
            case 'pol':
            case 'pod':
              record.route = selectedTableData.route
              break;
            case 'cargo_demand':
              record.capacity = selectedTableData.capacity
              break;
            case 'term':
              record.tug = selectedTableData.tug
              record.barge = selectedTableData.barge
              break;
            case 'status':
              record.activity_status = selectedTableData.activity_status
              break;

            default:
              break;
          }
          this.showFailedNotification(this, `${field.name.replace('_', ' ')} cannot be changed for Return Cargo trip.`)
          return ''
        }
      } else {
        if(field.name === 'end_user') {
          record[field.name] = oldContent
          this.showFailedNotification(this, `${field.name.replace('_', ' ')} cannot be changed for Not Return Cargo trip.`)
          return ''
        }
        if(this.isHasCheckpointActualData(record.dataID, field.name)) {
          record[field.name] = oldContent
          this.showFailedNotification(this, 'Checkpoint that has actual data cannot be edited')
          return
        }
        if(field.name === 'trip_number') {
          const tripNumbers = this.tableDataForExcel.filter(item => item.dataID !== record.dataID).map(item => item.trip_number)
          const isValid = !tripNumbers.includes(content)
          return isValid ? '' : 'Trip Number must be unique'
        }
        if(column.hasOwnProperty('isDate') && column.isDate && content) {
          const isValid = moment(content.trim(), 'DD-MMM-yyyy HH:mm', true).isValid()
          return isValid? '': 'Value is invalid format, format must be: DD-MMM-yyyy HH:mm'
        }
        if(column.hasOwnProperty('isNumber') && column.isNumber && content) {
          const isValid = Number(content)
          return isValid && isValid > 0? '' : 'Only positive numbers are allowed.'
        }
        if((field.name === 'status' || field.name === 'position') && selectedRecord.doc_assignment === 'PLAN') {
          record[field.name] = oldContent
          this.showFailedNotification(this, `${field.name} cannot be edited while document assignment is PLAN`)
          return ''
        }
        if(field.name === 'tug' && selectedRecord.doc_assignment !== 'PLAN') {
          record[field.name] = oldContent
          record.barge = selectedTableData.barge
          this.showFailedNotification(this, `${field.name} cannot be edited while document assignment is not PLAN`)
          return ''
        }
        if(field.name === 'barge' && selectedRecord.doc_assignment !== 'PLAN') {
          record[field.name] = oldContent
          record.tug = selectedTableData.tug
          this.showFailedNotification(this, `${field.name} cannot be edited while document assignment is not PLAN`)
          return ''
        }
        if(!column.isFreeInput && !column.isDate && !isEmpty(selectedOptions) && content) {
          const selectedOption = selectedOptions.some(so => so.text === content)
          return selectedOption? '' : 'This value is not in the options.'
        }
        if(column.hasOwnProperty('mandatory') && column.mandatory) {
          const isValid = !isEmpty(content)
          return isValid ? '' : 'This Field cannot be empty'
        }
      }
      return ''
    },
    async saveBulkEdit() {
      const clonedError = { ...this.$refs.excel.errmsg }
      if(!isEmpty(clonedError)) {
        const errorKeys = Object.keys(clonedError)
        const formattedError = errorKeys.map(item => {
          const parts = item.split('-')
          const selectedIndex = this.$refs.excel.filteredValue.findIndex(td=>td.$id === parts.slice(1, -1).join("-"))
          const selectedFields = this.$refs.excel.fields.find(fd=>fd.name ===  parts[parts.length - 1])
          return `column: ${selectedFields.label}, row: ${selectedIndex}`
        })
        const htmlList = `<ul style="margin:0; padding-left:20px;">${formattedError.slice(0,5).map(err => `<li>- ${err}</li>`).join("")}</ul>`
        this.showFailedNotification(this, `You have an error in ${htmlList}`)
      } else {
        try {
          const planGroup = this.tableHeaders.filter(th => th.group === 'simulation')
          const productTonnage = flatten(this.tableData.map(td => td.hasOwnProperty('blu_tonnage_per_products') ? td.blu_tonnage_per_products: null)).filter(f => f)
          this.editedItemsFromEditMode.forEach((items, index) => {
            if(items.hasOwnProperty('status')) {
              const selectedStatus = this.statusOptions.find(stat => stat.text === items.status)
              items.status = selectedStatus ? selectedStatus.value : items.status
            }
            Object.keys(items).forEach(key => {
              const selectedPlan = planGroup.some(pg=> pg.key === key)
              if(selectedPlan && key !== 'remark') {
                this.editedItemsFromEditMode[index].bargePlanActual = {
                  ...this.editedItemsFromEditMode[index].bargePlanActual,
                  [key]: new Date(this.editedItemsFromEditMode[index][key])
                }
                delete this.editedItemsFromEditMode[index][key]
              }
              if(key.includes('_')) {
                const productId = key.split('_')[1]
                const selectedProduct = productTonnage.find(bl => bl.product_id === productId)
                if(!isEmpty(selectedProduct)) {
                  this.editedItemsFromEditMode[index].blu_tonnage_per_products = [{...selectedProduct, tonnage: this.editedItemsFromEditMode[index][key]}]
                  delete this.editedItemsFromEditMode[index][key]
                }
              }
            })
          })
          this.isBulkEditProcessing = true
          if(this.editedItemsFromEditMode.length) {
            await this.$store.dispatch('BargeLineUp/putBulkBargeLineUp', this.editedItemsFromEditMode)
          }
          this.isBulkEditProcessing = false
          this.showSuccessNotification(this, 'Successfully saved changes')
          this.editedItemsFromEditMode = []
          this.isEditMode = false
          await this.fetchBarges()
        } catch (error) {
          this.isBulkEditProcessing = false
          const errorMessage = error?.error?.message || 'Failed to update BLU, please try again'
          this.showFailedNotification(this, errorMessage)
        }
      }
    },
    setEditedItems(key, row, value) {
      //Get Only edited items in edit mode
      const selectedItems = this.editedItemsFromEditMode.find(eItems => eItems.id === row.dataID && eItems.is_blu_return_cargo === row.is_blu_return_cargo)
      let selectedTugID = null
      let selectedBargeID = null
      let selectedVluId = null
      if(key === 'tug') {
        selectedTugID = this.editOptions.tug.find(td => td.text === value)
      }
      if(key === 'barge') {
        selectedBargeID = this.editOptions.barge.find(td => td.text === value)
      }
      if(key === 'end_user' && row.is_blu_return_cargo) {
        selectedVluId = this.editOptions.end_user.find(td => td.text === value)
      }
      if (selectedItems) {
        selectedItems[key] = value
        if(selectedTugID) {
          selectedItems.tug_id = selectedTugID.id
        }
        if(selectedBargeID) {
          selectedItems.barge_id = selectedBargeID.id
        }
        if(selectedVluId) {
          selectedItems.vessel_line_up_id = selectedVluId.value
        }
      } else {
        this.editedItemsFromEditMode = [...this.editedItemsFromEditMode, {
          id: row.dataID,
          [key]: value,
          is_blu_return_cargo: row.is_blu_return_cargo,
          ...( (row.is_blu_return_cargo && key === 'end_user' && selectedVluId) && { vessel_line_up_id: selectedVluId.value }),
          ...( selectedTugID && { tug_id: selectedTugID.id }),
          ...( selectedBargeID && { barge_id: selectedBargeID.id })
        }]
      }
    },
    async onCellChange(value, oldVal, row, field) {
      const key = field.name
      const selectedRecord = this.tableDataForExcel.find(tD=> tD.dataID === row.dataID && row.is_blu_return_cargo === tD.is_blu_return_cargo)
      const selectedTableData = this.tableData.find(item => item.id === row.dataID && row.is_blu_return_cargo === item.is_blu_return_cargo)
      if(BargeLineUpColumns.simulation.map(item => item.key ).includes(key) && this.validateAndFormatDate(value)) {
        await this.fetchCalculatedSimulation(row.dataID, row.is_blu_return_cargo, {[`${key}`]: new Date(value)})
        Object.keys(this.calculatedSimulation).forEach(key => {
          selectedRecord[key] = this.validateAndFormatDate(this.calculatedSimulation[key])
          this.setEditedItems(key, row, this.validateAndFormatDate(this.calculatedSimulation[key]))
        })
      } else {
        if (!row.is_blu_return_cargo || key === 'actual_quantity') {
          selectedRecord[key] = value
          this.tableDataForExcel = [...this.tableDataForExcel]
          this.setEditedItems(key, row, value)
        }
      }
      if(selectedRecord) {
        switch (key) {
          case 'end_user':
            if (row.is_blu_return_cargo) {
              const selectedEndUser = this.editOptions.end_user.find(v => v.text === value)
              selectedRecord.pod = selectedEndUser.pod
              this.setEditedItems('pod', row, selectedRecord.pod)
              selectedRecord.name_of_vessel = selectedEndUser.vessel_name
              this.setEditedItems('name_of_vessel', row, selectedRecord.name_of_vessel)
              selectedRecord.vessel_line_up_id = selectedEndUser.value
              this.setEditedItems('vessel_line_up_id', row, selectedRecord.vessel_line_up_id)
            } else {
              this.setEditedItems('end_user', row, oldVal)
            }
            break;
          case 'barge':
            if(selectedRecord.doc_assignment !== 'PLAN') {
              this.setEditedItems('barge', row, oldVal)
              break;
            }
            if(selectedRecord.term !== 'SPOT') {
              const selectedData = this.editOptions.tug.find(td => td.barge === value)
              if(selectedData) {
                selectedRecord.tug =  selectedData.text
                this.setEditedItems('tug', row, selectedRecord.tug)
              } else {
                selectedRecord.tug = null
                const selectedFieldTug = this.$refs.excel.fields.find(f => f.name === 'tug')
                this.$refs.excel.setFieldError('This field cannot be empty', row, selectedFieldTug )
              }
            }
            break;
          case 'tug':
            if(selectedRecord.doc_assignment !== 'PLAN') {
              this.setEditedItems('tug', row, oldVal)
              break;
            }
            if(selectedRecord.term !== 'SPOT') {
              const selectedBargeData = this.editOptions.barge.find(td => td.tug === value)
              if(selectedBargeData) {
                selectedRecord.barge = selectedBargeData.text
                this.setEditedItems('barge', row, selectedRecord.barge)
              } else {
                selectedRecord.barge = null
                const selectedFieldBarge = this.$refs.excel.fields.find(f => f.name === 'barge')
                this.$refs.excel.setFieldError('This field cannot be empty', row, selectedFieldBarge )
              }
            }
            break;
          case 'pol':
            selectedRecord.route = `${value}-${selectedRecord.pod}`;
            this.setEditedItems('route', row, selectedRecord.route)
            break;
          case 'pod':
            selectedRecord.route = `${selectedRecord.pol}-${value}`
            this.setEditedItems('route', row, selectedRecord.route)
            break;
          case 'actual_quantity':
            selectedRecord.capacity = this.evaluate(`(${value || 0}/${selectedRecord.cargo_demand || 0})*100`)
            this.setEditedItems('capacity', row, selectedRecord.capacity)
            break;
          case 'cargo_demand':
            selectedRecord.capacity = this.evaluate(`(${selectedRecord.actual_quantity || 0}/${value || 0})*100`)
            this.setEditedItems('capacity', row, selectedRecord.capacity)
            break;
          case 'term':
            const tugOptions = await this.fetchDropdownByType('TUG', value)
            const selectedOptions = tugOptions.find(tOpt=> tOpt.text === selectedRecord.tug)
            if(!selectedOptions) {
              selectedRecord.tug = ''
              const selectedField = this.$refs.excel.fields.find(f => f.name === 'tug')
              this.$refs.excel.setFieldError('This field cannot be empty', row, selectedField )
            }
            const bargeOptions = await this.fetchDropdownByType('BARGE', value)
            const selectedBargeOptions = bargeOptions.find(bOpt => bOpt.text === selectedRecord.barge)
            if(!selectedBargeOptions) {
              selectedRecord.barge = ''
              const selectedField = this.$refs.excel.fields.find(f => f.name === 'barge')
              this.$refs.excel.setFieldError('This field cannot be empty', row, selectedField )
            }
            break;
          case 'position':
            if(selectedRecord.doc_assignment === 'PLAN') {
              this.setEditedItems('pod', row, oldVal)
            }
            break;
          case 'status':
            if(selectedRecord.doc_assignment === 'PLAN') {
              this.setEditedItems('status', row, oldVal)
              break;
            }
            if(selectedTableData.status === value) {
              selectedRecord.activity_status = selectedTableData.activity_status
            }else {
              selectedRecord.activity_status = 'N/A'
            }
            break;
          case 'name_of_vessel':
            const selectedNameOfVessel = this.editOptions.name_of_vessel.find(v => v.text === value)
            this.setEditedItems('pod', row, selectedNameOfVessel.pod)
            selectedRecord.pod = selectedNameOfVessel.pod
            this.setEditedItems('end_user', row, selectedNameOfVessel.end_user)
            selectedRecord.end_user = selectedNameOfVessel.end_user
            this.setEditedItems('vessel_line_up_id', row, selectedNameOfVessel.id)
            selectedRecord.vessel_line_up_id = selectedNameOfVessel.id
            this.setEditedItems('name_of_vessel', row, value)
            break;
          case this.isHasCheckpointActualData(row.dataID, key):
            this.setEditedItems(key, row, oldVal)
            break
          default:
            break
        }
      }
    },
    fetchOptionsOnCreate() {
      this.fetchVesselItems()
      this.fetchBargeItems()
      this.fetchTermItems()
      this.fetchTugItems()
      this.fetchLocations()
    },
    populateDynamicData() {
      const productHeaders = _.flatten(
        this.tableData
          .filter(td => td.blu_tonnage_per_products?.length)
          .map(td =>
            td.blu_tonnage_per_products.map(tdb => ({
              key:
                tdb.type === 'INTERNAL'
                  ? `${tdb.company_code.toLowerCase()}_${tdb.product_id}`
                  : `third_party_${tdb.product_id}`,
              label: tdb.product_id,
              group:
                tdb.type === 'INTERNAL'
                  ? tdb.company_code.toLowerCase()
                  : '3rd Party',
              isProduct: true,
              sortKey: `product_id:${tdb.product_id}`,
              sortable: true
            }))
          )
      )

      const finalProductHeaders = _.uniqBy(productHeaders, 'key').sort((a, b) => {
        if (a.group === '3rd Party' && b.group !== '3rd Party') return 1
        if (b.group === '3rd Party' && a.group !== '3rd Party') return -1
        return a.label.localeCompare(b.label)
      })

      const groupHeadersPurpose = _.groupBy(finalProductHeaders, 'group')

      this.groupHeaders = Object.keys(groupHeadersPurpose).map(key => ({
        key: key.toLowerCase(),
        title: key.includes('3rd') ? key : key.toUpperCase(),
        startColumn: groupHeadersPurpose[key][0].key,
        endColumn: groupHeadersPurpose[key][groupHeadersPurpose[key].length - 1].key,
        backgroundColor: '#FFC10733'
      }))

      const finalStaticColumnsIndex = this.tableHeaders.findIndex(
        th => th.key.toLowerCase() === 'capacity'
      )
      this.tableHeaders.splice(finalStaticColumnsIndex + 1, 0, ...finalProductHeaders)

      this.productKey = Object.fromEntries(
        Object.entries(groupHeadersPurpose).map(([key, arr]) => [
          key === '3rd Party' ? 'third_party' : key,
          arr.map(gk => gk.label)
        ])
      )

    },
    generateProductSlots() {
      return Object.keys(this.productKey)
        .flatMap((group) => this.productKey[group].map((item) => ({
          group: group,
          label: item,
          slot_name: `${group}_${item}`,
          placeholder: item
        })))
    },
    disabledDate(date, selecting) {
      // selecting[0] = first selected date in range
      if (selecting && selecting.length === 1) {
        const first = selecting[0]
        const max = new Date(first)
        max.setMonth(max.getMonth() + 11) // +2 = allow first + 2 months (3 total)
        const min = new Date(first)
        return date < min || date > max
      }
      return false // allow all if no first date yet
    },
    async fetchBarges() {
      this.isBusy = true
      try {
        const params = {
          ...this.filter,
          ...(this.filter.name_of_vessel.length && { name_of_vessel: this.filter.name_of_vessel.map(item => item.value).join(',') }),
          ...(this.filter.barge.length && { barge: this.filter.barge.map(item => item.value).join(',') }),
          ...(this.filter.route.length && { route: this.filter.route.map(item => item.value).join(',') }),
          ...(this.filter.product_id.length && { product_id: this.filter.product_id.map(item => item.value).join(',') }),
          ...(this.filter.doc_assignment.length && { doc_assignment: this.filter.doc_assignment.map(item => item.value).join(',') }),
          is_tentative_barge_schedule: false
        }
        if (!isEmpty(params.date[0])) {
          params.loading_date_start = moment(params.date[0], 'MMM-YYYY').format('MM-YYYY')
          params.loading_date_end = moment(params.date[1], 'MMM-YYYY').format('MM-YYYY')
          delete params.date
        } else {
          delete params.date
        }
        await this.$store.dispatch('BargeLineUp/getBarges', params)
        this.isBusy = false
      } catch (err) {
        this.showFailedNotification(this, 'Cannot fetch data, please try again')
        this.isBusy = false
      }
    },
    async fetchVesselItems() {
      this.fetchLoading = { ...this.fetchLoading, vesselOptions: true }
      await this.$store.dispatch('BargeLineUp/getVesselItems')
      this.fetchLoading = { ...this.fetchLoading, vesselOptions: false }
    },
    async fetchBargeItems() {
      this.fetchLoading = { ...this.fetchLoading, bargeOptions: true }
      const params = {
        sort_by: 'name',
        sort_dir: 'asc',
        page: null,
        limit: null,
        is_get_deleted: false,
        is_include_inactive: true
      }
      await this.$store.dispatch('BargeManagement/fetchBargeManagementsUnpaginated', params)
      this.fetchLoading = { ...this.fetchLoading, bargeOptions: false }
    },
    async fetchTermItems() {
      await this.$store.dispatch('BargeLineUp/getTermItems')
    },
    async fetchTugItems() {
      await this.$store.dispatch('BargeLineUp/getTugItems')
    },
    async fetchProductIdItems(id) {
      await this.$store.dispatch('BargeLineUp/getProductIdItems', { id: id })
    },
    async fetchRouteItems() {
      this.fetchLoading = { ...this.fetchLoading, routeOptions: true }
      await this.$store.dispatch('BargeLineUp/getRouteItems')
      this.fetchLoading = { ...this.fetchLoading, routeOptions: false }
    },
    async fetchProductItems() {
      this.fetchLoading = { ...this.fetchLoading, productOptions: true }
      await this.$store.dispatch('BargeLineUp/getProductItems')
      this.fetchLoading = { ...this.fetchLoading, productOptions: false }
    },
    async fetchLatestPol(polName) {
      await this.$store.dispatch('BargeLineUp/getLatestPol', polName)
    },
    async fetchLatestPod(podName, vesselName) {
      await this.$store.dispatch('BargeLineUp/getLatestPod', { podName, vesselName })
    },
    async fetchBargeDetail(id = null, is_blu_return_cargo = false) {
      try {
        const bargeId = id !== null ? id : this.currentActiveRow?.id
        await this.$store.dispatch('BargeLineUp/getBargeDetail', {id: bargeId, is_blu_return_cargo})
      } catch (err) {
        this.showFailedNotification(this, 'Failed to fetch BLU detail data')
      }
    },
    async getVesselLineUp() {
      try {
        await this.$store.dispatch('VesselLineUp/getVesselLineUpDetail', this.currentVluId)
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch VLU, please try again')
      }
    },
    async fetchBargeHistories(id, isBluReturnCargo) {
      try {
        const dataIndex = this.tableData.findIndex((data) => data.id === id && data.is_blu_return_cargo === isBluReturnCargo)
        if (dataIndex !== -1) {
          const data = await this.$store.dispatch('BargeLineUp/fetchBluHistories', { id: id, is_blu_return_cargo: isBluReturnCargo })
          if (data?.error) {
            this.tableData[dataIndex].histories = []
            return
          }

          this.tableData[dataIndex].histories = data.map((item) => ({
            ...item,
            product_id: typeof item.product_id === 'string' ?  item.product_id : item.product_id.length > 1 ? item.product_id.join(',') : item.product_id[0],
            shipper_name: item.shipper ? item.shipper.name : '',
            histories: []
          }))
          await this.$nextTick(() => {
            this.syncRowHeights()
          })
        }
      } catch (err) {
        this.showFailedNotification(this, 'Failed to fetch BLU History')
      }
    },
    async fetchDropdownOptionsBLU(filter) {
      this.isOnDropdownDataFetch = true
      await this.$store.dispatch('BargeLineUp/getDropdownOptionsBLU', { ...filter }) // filter = {search, term, type}
      this.isOnDropdownDataFetch = false
    },
    async fetchLocations() {
      try {
        const params = {
          sort_by: 'name',
          sort_dir: 'asc',
          page: null,
          limit: null,
          location_type: ['Port-POD', 'Port-POL'],
          is_get_deleted: false
        }
        await this.$store.dispatch('LocationManagement/fetchLocationsUnpaginated', params)
      } catch (err) {
        this.showFailedNotification(this, 'Failed to fetch POL and POD, please try again')
      }
    },
    async uploadDelayTime(file) {
      try {
        await this.$store.dispatch('BargeLineUp/uploadDelayTime', file)
      } catch (err) {
        this.showFailedNotification(this, 'Failed to upload excel, please try again')
      }
    },
    async submitDelayTime() {
      try {
        await this.$store.dispatch('BargeLineUp/postDelayTime', this.delayTime)
        this.isDelayModalShown = false
        this.isPopUpShown = true
      } catch (err) {
        this.isDelayModalShown = false
        this.showFailedNotification(this, err.message)
      }
    },
    previewDelayTime() {
      this.bargeDelayTimePreview = { ...this.bargeDelayTimePreview }
    },
    onDelayTimeFieldChange(item) {
      this.delayTime = item
    },
    sort(sortBy, sortDir) {
      this.filter.sort_by = sortBy
      this.filter.sort_dir = sortDir

      this.fetchBarges()
    },
    resetFilters() {
      this.filter = {
        name_of_vessel: [],
        barge: [],
        route: [],
        product_id: [],
        doc_assignment: [],
        date: [moment().format('MMM-YYYY'), moment().format('MMM-YYYY')]
      }
      this.$refs.tabletop.$emit('reset-search')
      this.fetchBarges()
    },
    toggleRow(tr) {
      const index = this.expandedRowsList.indexOf(`${tr.id}-${tr.is_blu_return_cargo}`)
      if (index > -1) {
        tr.isExpand = false
        this.expandedRowsList.splice(index, 1) // Collapse
      } else {
        tr.isExpand = true
        this.expandedRowsList.push(`${tr.id}-${tr.is_blu_return_cargo}`) // Expand
        this.fetchBargeHistories(tr.id, tr.is_blu_return_cargo)
      }
    },
    generateBadgeStyle(status, type) {
      if (!status) {
        return ''
      }
      if(type === 'doc_assignment') {
        return this.docAssignmentColor[status.replace(' ', '_')]
      }
      let selectedColorCode = this.statusOptions.find(stat => stat.value.toLowerCase() === status.toLowerCase() || stat.text.toLowerCase() === status.toLowerCase())
      if(!selectedColorCode) {
        selectedColorCode = { color_code: '#818181' }
      }
      return { color: selectedColorCode.color_code, background: `${selectedColorCode.color_code}40` }
    },

    /**
     * Downloads the Barge Line-Up report based on the provided template and filter parameters.
     *
     * @param {string} template - The template format for the download (optional).
     * @return {Promise<void>} Resolves when the report has been downloaded or rejects if there is an error during the process.
     */
    async downloadBOReport(template) {
      try {
        this.fetchLoading = { ...this.fetchLoading, exportBLU: {...this.fetchLoading.exportBLU, [template]: true} }
        const params = {
          ...this.filter,
          ...(this.filter.name_of_vessel.length && { name_of_vessel: this.filter.name_of_vessel.map(item => item.value).join(',') }),
          ...(this.filter.barge.length && { barge: this.filter.barge.map(item => item.value).join(',') }),
          ...(this.filter.route.length && { route: this.filter.route.map(item => item.value).join(',') }),
          ...(this.filter.doc_assignment.length && { doc_assignment: this.filter.doc_assignment.map(item => item.value).join(',') }),
          ...(this.filter.product_id.length && { product_id: this.filter.product_id.map(item => item.value).join(',') }),
          ...(template && { template: template })
        }
        if (!isEmpty(params.date[0])) {
          params.loading_date_start = moment(params.date[0], 'MMM-YYYY').format('MM-YYYY')
          params.loading_date_end = moment(params.date[1], 'MMM-YYYY').format('MM-YYYY')
        }

        const { date, ...newParams } = params
        await this.$store.dispatch(
          'BargeLineUp/downloadBargeLineUps',
          newParams,
          {
            headers: {
              accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
        )
        this.fetchLoading = { ...this.fetchLoading, exportBLU: {...this.fetchLoading.exportBLU, [template]: false} }
        this.isDownload = false
      } catch (error) {
        this.fetchLoading = { ...this.fetchLoading, exportBLU: {...this.fetchLoading.exportBLU, [template]: false} }
        this.isDownload = false
        this.showFailedNotification(this, 'Failed to download barge line up, please try again')
      }
    },
    syncRowHeights() {
      const frozenRows = document.querySelectorAll('.history-row.frozen')
      const scrollableRows = document.querySelectorAll('.history-row.scrollable')

      for (let i = 0; i < frozenRows.length; i++) {
        const frozen = frozenRows[i]
        const scrollable = scrollableRows[i]
        const maxHeight = Math.max(frozen.offsetHeight, scrollable.offsetHeight)

        frozen.style.height = `${maxHeight}px`
        scrollable.style.height = `${maxHeight}px`
      }
    },
    validateAndFormatDate(date, format = 'DD-MMM-YYYY HH:mm') {
      if (!date || date === '-') {
        return null
      }
      const parsedDate = this.moment(date, ['DD-DD/M', 'YYYY-MM-DDTHH:mm:ss.SSSSZ', format], true)
      if (parsedDate.isValid()) {
        if (this.moment(date, format, true).isValid()) { // date already in correct format
          return date
        }
        return moment.utc(parsedDate).local().format(format)
      }
      return null
    },
    isInvalidCell(cellDetails) {
      const isValidValue = (!cellDetails.value || (Array.isArray(cellDetails.value) && !cellDetails.value?.length))
      return (cellDetails.hasOwnProperty('isError') && cellDetails.isError) || (cellDetails.hasOwnProperty('isValid') && isValidValue)
    },
    async fetchActivityStatusByTripStatus(tripStatusId) {
      try {
        await this.$store.dispatch('KeyActivityStatus/getActivityStatusByTripStatus', tripStatusId)
      } catch (error) {
        const errorMessage = error?.error?.message || 'Failed to get activity status options, please try again'
        this.showFailedNotification(this, errorMessage)
      }
    },
    async fetchDropdownByType(type, term,  blu_id, tug_id, barge_id) {
      try {
        await this.fetchDropdownOptionsBLU(
          {
            ...(term && {term}),
            ...(blu_id && {blu_id}),
            ...(tug_id && {tug_id}),
            ...(barge_id && {barge_id}),
            type
          }
        )
        switch (type) {
          case 'BARGE':
            return this.dropdownOptions.map(val => ({ value: val.barge, text: val.barge, id: val.barge_id , tug: val.tug }))
          case 'TUG':
            return this.dropdownOptions.map(val => ({ value: val.tug, text: val.tug, id: val.tug_id, barge: val.barge }))
          case 'DOC_ASSIGNMENT':
            return this.dropdownOptions.map((val, i) => ({ value: val, text: val, id: i}))
          case 'POD':
            return this.podItems.map(val => ({ value: val.name, text: val.name, id: val.id, alias: val.alias || null }))
          case 'POL':
            return this.polItems.map(val => ({ value: val.name, text: val.name, id: val.id, alias: val.alias || null }))
          case 'SHIPPER':
            return this.dropdownOptions.map(val => ({ value: val.name, text: val.name, id: val.id, alias: val.alias || null }))
          case 'TRIP_STATUS':
            return this.dropdownOptions.map(val => ({ value: val.code, text: val.name, id: val.id, color_code: val.color_code }))
          case 'RETURN_CARGO_VLU':
            return this.dropdownOptions.map(val => ({
              value: val.id,
              text: val.end_user,
              pod: val.pod,
              vessel_name: val.vessel_name
            }))
          case 'MAIN_CARGO_VLU':
            return this.dropdownOptions.map(val => ({
              value: val.vessel_name,
              text: val.vessel_name,
              end_user: val.end_user,
              pod: val.pod,
              id: val.id
            }))
          default:
            return []
        }
      } catch {
        return []
      }
    },
    async setDropdownOptions(row) {
      const selectedDefaultStatus = row.status === 'COMPLETED' ? 'HOME' : row.status
      const selectedStatus = this.editOptions.status.find(s => s.value === selectedDefaultStatus || s.text === selectedDefaultStatus)
      if(selectedStatus && selectedStatus.id) {
        await this.fetchActivityStatusByTripStatus(selectedStatus.id)
      }
      const term = row.term === 'STTC'? 'TC': row.term
      this.editOptions.barge = await this.fetchDropdownByType('BARGE', term )
      this.editOptions.tug = await this.fetchDropdownByType('TUG', term )
      const selectedTug = this.editOptions.tug.find(t => t.text === row.tug)
      const selectedBarge = this.editOptions.barge.find(t => t.text === row.barge)
      if(isEmpty(selectedTug)) {
        this.editOptions.tug.push({id: this.bargeDetail.tug_id, text: this.bargeDetail.tug, value: this.bargeDetail.tug})
      }
      if(isEmpty(selectedBarge)) {
        this.editOptions.barge.push({id: this.bargeDetail.barge_id, text: this.bargeDetail.barge, value: this.bargeDetail.barge})
      }
      this.editOptions.doc_assignment = await this.fetchDropdownByType( 'DOC_ASSIGNMENT', null, row.id, this.bargeDetail.tug_id, this.bargeDetail.barge_id )
      this.editOptions.shipper = await this.fetchDropdownByType( 'SHIPPER')
      this.editOptions.POL = await this.fetchDropdownByType( 'POL')
      this.editOptions.POD = await this.fetchDropdownByType( 'POD')
      if(this.activityStatusOptions.length) {
        this.editOptions.activity_status = this.activityStatusOptions.map(item => ({ value: item.name, text: item.name, id: item.id }))
      }
      if(row.is_blu_return_cargo) {
        this.editOptions.end_user = await this.fetchDropdownByType('RETURN_CARGO_VLU', null, row.id)
      } else {
        this.editOptions.name_of_vessel = await this.fetchDropdownByType('MAIN_CARGO_VLU', null, row.id)
      }
    },
    async startEdit(row) {
      if (this.tableData.some(r => r?.isEditing)) {
        this.showFailedNotification(
          this,
          'Only one action can be active at a time. \n' + 'Please save your changes first.',
          'Error'
        )
        return
      }
      this.isStartEditLoading = row.id
      this.isReturnCargo = row.is_blu_return_cargo
      await this.fetchBargeDetail(row.id, row.is_blu_return_cargo)
      await this.setDropdownOptions(row)
      this.isStartEditLoading = null
      this.isReturnCargo = null
      const editFormFields = this.tableHeaders
        .filter(({ key }) => key !== 'no' && key !== 'action')
        .map(({ key, group, isValid, isDate, isProduct, label, formula }) => ({
          key,
          ...(isValid && { isValid }),
          ...(isDate && { isDate }),
          ...(group === 'simulation' && { lookupArray: 'checkpoint_simulation' }),
          ...(isProduct && { isProduct, group, label }),
          ...(formula && { formula })
        }))

      const editForm = editFormFields
        .reduce((acc, field) => {
          const form = {}
          if (field?.isValid) {
            form['isValid'] = field.isValid
          }

          if (field?.formula) {
            form['formula'] = field.formula
          }

          if (field?.lookupArray && field.key !== 'remark') {
            form['value'] = field?.isDate
              ? this.validateAndFormatDate(row[field.lookupArray] ?  row[field.lookupArray][field.key] : null)
              : row[field.lookupArray] ? row[field.lookupArray][field.key] || null : null
          } else if (field.isProduct) {
            form['value'] = row[field.group]?.find(product => product?.name === field.label)?.tonnage || 0
          } else if (field?.isDate) {
            form['value'] = this.validateAndFormatDate(row[field.key]) || null
          } else {
            form['value'] = this.parseGeneralDetailData(field.key, row[field.key], row.is_blu_return_cargo) || null
          }
          acc[field.key] = form

          return acc
        }, {})

      if(row.is_blu_return_cargo) {
        editForm.vessel_line_up_id = row.vessel_line_up_id
        editForm.is_blu_return_cargo = row.is_blu_return_cargo
      }

      const index = this.tableData.findIndex(item => item.id === row.id && item.is_blu_return_cargo === row.is_blu_return_cargo)
      if (index !== -1) {
        this.$set(this.tableData[index], 'isEditing', true)
        this.$set(this.tableData[index], 'editForm', editForm)
      }
    },
    isHaveErrors() {
      let inValid = false
      Object.keys(this.currentActiveRow.editForm).forEach((key) => {
        if(this.currentActiveRow.editForm[key].hasOwnProperty('isError') && this.currentActiveRow.editForm[key].isError){
          inValid = true
        }
      })
      return inValid
    },
    async saveEdit() {
      if (this.validate()) {
        this.showFailedNotification(this, 'Some fields is empty, please fill it first')
        return
      }

      if(this.isHaveErrors()) {
        this.showFailedNotification(this, 'Trip Number must be unique')
        return
      }

      try {
        const dataToSubmit = this.generateSubmitData()
        let editedData = {
          id: this.currentActiveRow.id,
          ...(dataToSubmit.is_blu_return_cargo ? { is_blu_return_cargo: dataToSubmit.is_blu_return_cargo} : null)
        }
        editedData = { ...editedData, ...this.parseArrayOnEdit(dataToSubmit) }
        editedData = { ...editedData, ...this.parseNonArrayOnEdit(dataToSubmit) }

        this.formCompanies.forEach(item => {
          const index = Object.keys(this.productKey).findIndex(key => key === item.key)
          if (index > -1) {
            editedData = {
              ...editedData,
              actual_tonnage: [
                ...(editedData?.actual_tonnage || []),
                ...this.productKey[item.key].map(key => ({
                  name: key,
                  tonnage: this.currentActiveRow.editForm[`${item.key}_${key}`].value || 0
                }))
              ]
            }
          }
        })
        if (!editedData.third_party) {
          editedData.third_party = []
        }
        if(editedData.shipper_name) {
          editedData.shipper_id = this.editOptions.shipper.find(ship=> ship.text === editedData.shipper_name).id
          delete editedData.shipper_name
        }
        this.fetchLoading = { ...this.fetchLoading, saveEdit: true }
        await this.$store.dispatch('BargeLineUp/putBargeLineUp', editedData)
        this.showSuccessNotification(this, 'Successfully saved changes')
        this.fetchLoading = { ...this.fetchLoading, saveEdit: false }
        this.cancelAllEdits()

        await this.fetchBarges()
        await this.fetchProductItems() // Reset Product ID options to default
      } catch (error) {
        this.fetchLoading = { ...this.fetchLoading, saveEdit: false }
        const errorMessage = error?.error?.message || error?.data?.error?.message || 'Failed to update BLU, please try again'
        this.showFailedNotification(this, errorMessage)
      }
    },
    cancelEdit(row) {
      const index = this.tableData.findIndex(({ id, is_blu_return_cargo }) => id === row.id && is_blu_return_cargo === row.is_blu_return_cargo)
      if (index !== -1) {
        this.$set(this.tableData[index], 'isEditing', false)
        this.$set(this.tableData[index], 'editForm', null)
      }
    },
    cancelAllEdits() {
      this.tableData.forEach(row => {
        if (row?.isEditing) {
          this.$set(row, 'isEditing', false)
          this.$set(row, 'editForm', null)
        }
      })
    },
    countActualQty() {
      const actualQty = this.currentActiveRow?.editForm?.actual_quantity
      const capacity = this.currentActiveRow?.editForm?.capacity
      if (!capacity.value) {
        capacity.value = parseInt((actualQty.value / this.currentActiveRow?.editForm?.cargo_demand.value * 100).toFixed()) || 0
      }
    },
    syncProductTonnage(key) {
      if (key === 'cargo_demand' || key === 'actual_quantity') {
        const { capacity, cargo_demand, actual_quantity } = this.currentActiveRow?.editForm
        capacity.value = parseInt((actual_quantity.value / cargo_demand.value * 100).toFixed()) || 0
        return
      }

      const keyPrefix = key?.includes('third_party')
        ? 'third_party'
        : key?.split('_')?.[0] || null
      if (Object.keys(this.productKey).includes(keyPrefix)) {
        this.countActualQty()
      }
    },
    generateSubmitData() {
      const editForm = this.currentActiveRow.editForm
      let generalData = {}
      let companyData = {}
      let planData = {}

      // General
      this.formGeneral.forEach(item => {
        generalData = {
          ...generalData,
          [item.key]: this.parseGeneralDataForSubmit(item)
        }
      })
      generalData['barge_id'] = editForm?.barge?.value?.id
      generalData['tug_id'] = editForm?.tug?.value?.id

      // Products
      const products = this.generateProductSlots()
      products.forEach(product => {
        if (product.group === 'third_party') {
          const productDetail = {
            name: product.label,
            tonnage: editForm[product.slot_name].value || 0,
            percentage: editForm[product.slot_name].value / editForm.actual_quantity.value * 100
          }
          if (companyData.hasOwnProperty(product.group) && Array.isArray(companyData[product.group])) {
            companyData[product.group].push(productDetail)
          } else if (companyData.hasOwnProperty(product.group) && typeof companyData[product.group] === 'object') {
            // convert object to array
            companyData[product.group] = Object.keys(companyData[product.group]).map(key => ({
              name: key,
              tonnage: companyData[key]
            }))
            companyData[product.group].push(productDetail)
          } else {
            companyData = {
              ...companyData,
              [product.group]: [productDetail]
            }
          }
        } else {
          const productDetail = {
            name: product.label,
            tonnage: editForm[product.slot_name].value || 0,
            percentage: editForm[product.slot_name].value / editForm.actual_quantity.value * 100
          }
          if (companyData.hasOwnProperty(product.group)) {
            companyData[product.group].push(productDetail)
          } else {
            companyData = {
              ...companyData,
              [product.group]: [productDetail]
            }
          }
        }
      })

      // SIMULATION
      this.formPlan.forEach(item => {
        planData = {
          ...planData,
          [item.key]: editForm[item.key].value
        }
      })
      let remark = null
      if (planData?.remark) {
        remark = planData?.remark
        delete planData.remark
      }

      return {
        ...generalData,
        ...companyData,
        bargePlanActual: planData,
        remark,
        vessel_line_up_id: editForm.vessel_line_up_id,
        is_blu_return_cargo: editForm.is_blu_return_cargo
      }
    },
    parseGeneralDetailData(key, rawValue, isReturnCargo) {
      switch (key) {
        case 'name_of_vessel':
          if(isReturnCargo) return rawValue
          return this.editOptions.name_of_vessel.find(vessel => vessel.text === rawValue) || null
        case 'barge':
          return this.editOptions.barge.find(barge => barge.text === rawValue) || null
        case 'term':
          return this.termOptions.find(term => term.text === rawValue) || null
        case 'tug':
          return this.editOptions.tug.find(tug => tug.text === rawValue) || null
        case 'pol':
          return this.editOptions.POL.find(pol => pol.text === rawValue || pol.alias === rawValue) || null
        case 'pod':
          return this.editOptions.POD.find(pod => pod.text === rawValue || pod.alias === rawValue) || null
        case 'status':
          return this.statusOptions.find(status => status.text.toUpperCase() === rawValue.toUpperCase() || status.value.toUpperCase() === rawValue.toUpperCase()) || null
        case 'kpi_code':
          return this.kpiOptions.find(kpi => kpi.text === rawValue) || null
        case 'doc_assignment':
          return this.editOptions.doc_assignment.find(doc=> doc.text === rawValue) || null
        case 'shipper_name':
          return this.editOptions.shipper.find(shipper => shipper.text === rawValue) || null
        case 'trade_type':
          return this.TRADE_OPTIONS.find(option => option.text === rawValue) || null
        case 'activity_status':
          return this.editOptions.activity_status.find(status => status.text === rawValue) || null
        default:
          return rawValue
      }
    },
    parseGeneralDataForSubmit(item) {
      const editForm = this.currentActiveRow.editForm
      const currentField = editForm[item.key]
      switch (true) {
        case typeof currentField.value === 'object' && currentField.value !== null:
          return currentField.value?.text
        case item.isDate:
          return currentField.value
        default:
          return currentField.value
      }
    },
    parseNonArrayOnEdit(dataToSubmit) {
      let editedData = {}
      Object.keys(dataToSubmit)
        .filter((key) => !Array.isArray(dataToSubmit[key]))
        .forEach(key => {
          switch (true) {
            case key === 'id':
              editedData = { ...editedData, [key]: this.bargeDetail[key] }
              break
            case typeof dataToSubmit[key] === 'undefined' || dataToSubmit[key] === null:
              if(key === 'activity_status') {
                return editedData = { ...editedData, [key]: '' }
              }
              break
            case key === 'third_party':
              const filteredThirdParty = this.differenceWith([dataToSubmit[key]], [this.bargeDetail[key]], this.isEqual)

              if (filteredThirdParty.length) {
                editedData = { ...editedData, [key]: filteredThirdParty[0] }
              }
              break
            case key === 'loading_date':
              const parsedOldValue = this.validateAndFormatDate(this.bargeDetail[key])

              if (!this.isEqual(dataToSubmit[key], parsedOldValue)) {
                editedData = { ...editedData, [key]: dataToSubmit[key] }
              }
              break
            case key === 'bargePlanActual': {
              const bargeDetailKeyPlan = 'bargePlanActuals'
              if (this.bargeDetail[bargeDetailKeyPlan].length) {
                const detailPlans = this.bargeDetail[bargeDetailKeyPlan].filter(data => data.type === 'Actual')
                if (detailPlans.length) {
                  let parsedPlan = {}
                  Object.keys(detailPlans[0]).forEach(key => {
                    switch (true) {
                      case key === 'id' || key === 'created_at':
                        parsedPlan = { ...parsedPlan }
                        break
                      case key === 'barge_cycle' || key === 'type' || !detailPlans[0][key]:
                        parsedPlan = { ...parsedPlan, [key]: detailPlans[0][key] }
                        break
                      default:
                        parsedPlan = {
                          ...parsedPlan,
                          [key]: this.validateAndFormatDate(detailPlans[0][key])
                        }
                        break
                    }
                  })
                  const filteredObject = {}
                  const keys = new Set([...Object.keys(dataToSubmit.bargePlanActual), ...Object.keys(parsedPlan)])
                  for (const key of keys) {
                    const a = dataToSubmit.bargePlanActual[key]
                    if (!!a) {
                      filteredObject[key] = a
                    }
                  }
                  if (Object.keys(filteredObject).length) {
                    editedData = { ...editedData, bargePlanActual: filteredObject }
                  }
                } else {
                  Object.keys(dataToSubmit.bargePlanActual).forEach(key => {
                    if(!dataToSubmit.bargePlanActual[key]) {
                      delete dataToSubmit.bargePlanActual[key]
                    } else {
                      switch (true) {
                        case key === 'id' || key === 'created_at' || key === 'barge_cycle' || key === 'type':
                          dataToSubmit.bargePlanActual = { ...dataToSubmit.bargePlanActual }
                          break
                        default:
                          dataToSubmit.bargePlanActual = {
                            ...dataToSubmit.bargePlanActual,
                            [key]: new Date(dataToSubmit.bargePlanActual[key])
                          }
                          break
                      }
                    }
                  })
                  editedData = { ...editedData, bargePlanActual: dataToSubmit.bargePlanActual }
                }
              }
              break
            }
            case dataToSubmit[key] !== this.bargeDetail[key]: // These properties are not accepted in back-end; do not send
              editedData = { ...editedData, [key]: dataToSubmit[key] }
              break
            default:
              break
          }
        })

      return editedData
    },
    parseArrayOnEdit(dataToSubmit) {
      let editedData = {}
      Object.keys(dataToSubmit)
        .filter((key) => Array.isArray(dataToSubmit[key]))
        .forEach((key) => {
          switch (key) {
            case 'product_id': {
              editedData = { ...editedData, [key]: dataToSubmit[key] }
              break
            }
            case 'product_id_unique': {
              editedData = { ...editedData, [key]: dataToSubmit[key] }
              break
            }
            default: {
              const productChanges = []

              const updatedProduct = _.filter(dataToSubmit[key], (submittedItem) => {
                const originalItem = _.find(this.bargeDetail[key], { name: submittedItem.name })

                return originalItem && _.some(['tonnage'], (key) =>
                  submittedItem[key] !== originalItem[key]
                )
              })
              if (updatedProduct.length > 0) {
                productChanges.push(...updatedProduct)
              }

              const productAdded = this.differenceBy(dataToSubmit[key], productChanges, 'name').filter(({ tonnage }) => tonnage !== 0)
              if (productAdded.length > 0) {
                productChanges.push(...productAdded)
              }

              if (productChanges.length > 0) {
                editedData = { ...editedData, [key]: productChanges }
              }
              break
            }
          }
        })

      return editedData
    },
    generateOptionsByKey(key) {
      switch (key) {
        case 'name_of_vessel':
          return this.editOptions.name_of_vessel
        case 'barge':
          return this.editOptions.barge
        case 'term':
          return this.termOptions
        case 'tug':
          return this.editOptions.tug
        case 'product_id':
          return this.productIdOptions
        case 'pol':
          return this.editOptions.POL
        case 'pod':
          return this.editOptions.POD
        case 'status':
          return this.statusOptions
        case 'kpi_code':
          return this.kpiOptions
        case 'trade_type':
          return this.TRADE_OPTIONS
        case 'doc_assignment':
          return this.editOptions.doc_assignment
        case 'shipper_name':
          return this.editOptions.shipper
        case 'activity_status':
          return this.editOptions.activity_status
        default:
          return []
      }
    },
    setCellStyle() {
      return {
        backgroundColor: 'white',
        border: '1px solid #e5e7eb',
        fontSize: '13px',
        padding: '4px 16px',
        color: '#333',
        fontWeight: 'normal'
      }
    },
    getRoute() {
      const { pol, pod, route } = this.currentActiveRow?.editForm
      const polItem = this.editOptions.POL.find(({ value }) => value === pol?.value?.value)
        ? pol?.value?.text
        : null

      const podItem = this.editOptions.POD.find(({ value }) => value === pod?.value?.value)
        ? pod?.value?.text
        : null

      route.value = `${polItem}-${podItem}`
    },
    calculateUnloading() {
      let calculateData = ''
      const { product_id } = this.currentActiveRow.editForm
      const blendingScheme = [...(this.productIdItems?.data ?? this.productIdItems ?? [])]
        .find(item => item.id === product_id?.value[0]?.value)
        ?.blending_scheme?.toLowerCase() || 'default'
      let method = this.vesselLineUpDetail.flf_fc_nominate?.name.toLowerCase()
      method = method === 'green calypso' ? 'fc' : method === 'shiploader' ? 'cbu' : method === 'whs iskandar' ? 'iskandar' : method
      const pod = this.currentActiveRow?.editForm?.pod?.value?.text?.toLowerCase()

      const podDurations = KEY_BARGE_LINE_UP_CALCULATE_UNLOADING_BERTHING_UNBERTHING.find(x => x.key === pod)
      const defaultPodDurations = KEY_BARGE_LINE_UP_CALCULATE_UNLOADING_BERTHING_UNBERTHING.find(x => x.key === 'default')

      calculateData = defaultPodDurations ?? null
      if (podDurations) {
        const flfDurations = podDurations.value.find(x => x.key === method)
        const defaultFlfDurations = podDurations.value.find(x => x.key === 'default')
        if (flfDurations) {
          if (method === 'cbu') {
            calculateData = flfDurations
          } else {
            const blendingDuration = Array.isArray(flfDurations.value)
              ? flfDurations.value.find(x => x.key === blendingScheme)
              : null

            calculateData = blendingDuration ?? null
          }
        }
        if (!calculateData || !flfDurations) {
          calculateData = defaultFlfDurations
        }
      }
      return calculateData
    },
    validate() {
      const editForm = this.currentActiveRow.editForm
      this.staticColumns
        .filter(item => item.hasOwnProperty('isValid'))
        .forEach(item => {
          const current = editForm[item.key]
          if (Array.isArray(current.value)) {
            current.isValid = !!current.value.length
            return
          }
          current.isValid = !!current.value
        })
      return Object.entries(editForm).some(([key, value]) => value.hasOwnProperty('isValid') && !value.isValid)
    },
    getProductIdOriginalName(productId) {
      const company = productId?.company?.toLowerCase() || null
      const product = productId?.product?.toLowerCase() || productId
      const productName = find(KEY_BARGE_LINE_UP_PRODUCT_DICTIONARY, function(o) {
        const formattedProduct = company === null
          ? product
          : product?.includes(company)
            ? product
            : `${company}_${product}`
        return o.aliases.map(alias => alias?.toLowerCase()).includes(formattedProduct?.toLowerCase())
      }) || null

      return {
        ...(isPlainObject(productId) && { ...productId }),
        originalName: productName?.original_name || null
      }
    },
    async setEditMode() {
      if(this.tableDataForExcel.length) {
        this.editOptions.barge = await this.fetchDropdownByType('BARGE' )
        this.editOptions.tug = await this.fetchDropdownByType('TUG' )

        this.isEditMode = true
      } else {
        this.showWarningNotification(this, 'Only planned & ongoing trips are allowed to be edited.')
      }
    },
    cancelEditMode() {
      this.isPopUpDiscardShown = false
      this.isEditMode = false
      this.fetchBarges()
    },
    onHandleShowDetail(row) {
      this.showBluDetail = !this.showBluDetail
      this.bluPlanId = row.id
    },
    onHandleReturnCargo(row) {
      this.showModalReturnCargo = !this.showModalReturnCargo
      this.isAddReturnCargo = !this.isAddReturnCargo
      this.bluPlanId = row.id
      this.tripNumber = row.trip_number
    },
    onHandleEndUserChange(vlu_id, row_id, is_blu_return_cargo) {
      if (vlu_id > -1) {
        const endUserData = this.editOptions.end_user.find(v => v.value === vlu_id)

        const selectedData = this.tableData.find(item => item.id === row_id && item.is_blu_return_cargo === is_blu_return_cargo)
        const index = this.tableData.findIndex(item => item.id === row_id && item.is_blu_return_cargo === is_blu_return_cargo)
        selectedData.editForm.name_of_vessel = {
          text: endUserData.vessel_name,
          value: endUserData.vessel_name
        }
        selectedData.editForm.pod.value = {
          text: endUserData.pod,
          value: endUserData.pod
        }
        this.$set(this.tableData[index], 'editForm', selectedData.editForm)
      }
    },
    onHandleNameOfVesselChange(val) {
      if(!val || this.currentActiveRow.editForm.is_blu_return_cargo) return
      const selectedPod = this.editOptions.POD.find(item => item.text === val.pod)
      this.currentActiveRow.editForm.vessel_line_up_id = val.id
      this.currentActiveRow.editForm.end_user = { value: val.end_user }
      if(selectedPod) {
        this.currentActiveRow.editForm.pod.value = selectedPod
      }
    },
    async closeReturnCargoModal() {
      this.showModalReturnCargo = false
      this.bluPlanId = null
      this.tripNumber = null
      await this.fetchBarges()
    },
    async onHandleSendEmail() {
      try {
        this.isSendEmail = true
        await this.$store.dispatch('BargeLineUp/postSendEmail')
        this.showSuccessNotification(this, 'Successfully send email')
        this.isSendEmail = false
      } catch (error) {
        this.isSendEmail = false
        const errorMessage = error?.data?.error?.message || 'Failed to send email BLU, please try again'
        this.showFailedNotification(this, errorMessage)
      }
    }
  },
  beforeCreate() {
    this.$store.dispatch('Table/resetConfig')
  }
}
</script>

<style lang="scss" scoped>
/deep/ .vs-con-input-label {
  width: 100%;
}

/deep/ .select-list {
  @apply w-full;
}

.filter-container {
  @apply p-5 mt-5 flex flex-row items-center bg-white rounded-lg;
}

.divider {
  border: solid 1px #DEDEDE;
}

.icon-transparent-bg {
  @apply cursor-pointer;
  @apply min-w-8;
  @apply h-8;
  background-color: #493493;
  border-radius: 0.5rem;

  &.complete {
    background-color: #D1F9E3;
  }

  &.delete {
    background-color: rgba(255, 99, 123, 0.16);
  }
}

.action-button {
  @apply py-0 #{!important} px-2 #{!important} ml-1;
}

.divider-bottom {
  @apply my-8;
  border: solid 0.5px #DEDEDE;
}


.badge-status {
  min-width: 10rem;
  text-align: center;
  padding: 5px 0;
  border-radius: 5px;
}

.history-row {
  @apply h-12;

  &.frozen {
    .td {
      &:first-child {
        @apply pl-10;
        @apply rounded-l-2xl;
      }
    }
  }

  &.scrollable {
    .td {
      &:last-child {
        @apply pr-10;
        @apply rounded-r-2xl;
      }
    }
  }

  .td {
    background: #FEF3F0;
    min-width: 120px;
    white-space: nowrap;
    box-sizing: border-box;
    overflow: visible;
    font-size: 10pt;

    border-top: 1px solid transparent;
    border-bottom: 1px solid transparent;

    &:first-child {
      @apply pl-10;
    }
  }
}

.select-add-container {
  min-width: fit-content;
  max-width: 14rem;

  /deep/ .bg-option-container {
    width: 14rem;
  }
}

.select-radio-container {
  min-width: fit-content;

  /deep/ .bg-option-container {
    width: fit-content;
  }
}

/deep/ .vs-input--icon {
  &.icon-after {
    padding-top: 2px;
    padding-right: .5rem;
    border: none;
    font-size: 1.5em;
  }
}

.is-not-valid {
  &.autonumeric-primary,
  /deep/ .vs-con-input,
  /deep/ .mx-input-wrapper,
  /deep/ .bg-accent-multiselect {
    @apply rounded-lg;
    outline: 2px solid #ff647c;
  }
}

/deep/ .vue-excel-editor span[data-v-cf2e49d2][style*="position: absolute"] {
  display: none !important;
}
</style>
